var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import starRibbon from "./assets/award-ribbon-star.png";
import successStatus from "./assets/checkmark-circle-icon.svg";
import connectDevices from "./assets/connect-devices.png";
import enabledBadgePlaceholder from "./assets/enabled-badge-placeholder.svg";
import garbageIcon from "./assets/garbage-icon.png";
import helpfulTipFallBackImage from "./assets/helpful-tip-fall-back-image.jpg";
import iconPivot from "./assets/icon-pivot.png";
import maxProgramEnrolmentImage from "./assets/max-program-enrolment-image.png";
import clock from "./assets/time-clock-circle.png";

// src/types/health-programs-asset-map.types.ts
var HEALTH_PROGRAMS_ASSET_KEYS = /* @__PURE__ */ ((HEALTH_PROGRAMS_ASSET_KEYS2) => {
  HEALTH_PROGRAMS_ASSET_KEYS2["STAR_RIBBON"] = "STAR_RIBBON";
  HEALTH_PROGRAMS_ASSET_KEYS2["SUCCESS_STATUS"] = "SUCCESS_STATUS";
  HEALTH_PROGRAMS_ASSET_KEYS2["CLOCK"] = "CLOCK";
  HEALTH_PROGRAMS_ASSET_KEYS2["CONNECT_DEVICES"] = "CONNECT_DEVICES";
  HEALTH_PROGRAMS_ASSET_KEYS2["ENABLED_BADGE_PLACEHOLDER"] = "ENABLED_BADGE_PLACEHOLDER";
  HEALTH_PROGRAMS_ASSET_KEYS2["GARBAGE_ICON"] = "GARBAGE_ICON";
  HEALTH_PROGRAMS_ASSET_KEYS2["HELPFUL_TIP_FALL_BACK_IMAGE"] = "HELPFUL_TIP_FALL_BACK_IMAGE";
  HEALTH_PROGRAMS_ASSET_KEYS2["DEVICE_CONNECTION_ERROR_ICON"] = "DEVICE_CONNECTION_ERROR_ICON";
  HEALTH_PROGRAMS_ASSET_KEYS2["MAX_PROGRAM_ENROLMENT_IMAGE"] = "MAX_PROGRAM_ENROLMENT_IMAGE";
  return HEALTH_PROGRAMS_ASSET_KEYS2;
})(HEALTH_PROGRAMS_ASSET_KEYS || {});

// src/asset-map.ts
var {
  STAR_RIBBON,
  SUCCESS_STATUS,
  CLOCK,
  // TODO - JRNY - Update tokens to reflect the source-of-truth when they become available
  CONNECT_DEVICES,
  ENABLED_BADGE_PLACEHOLDER,
  GARBAGE_ICON,
  HELPFUL_TIP_FALL_BACK_IMAGE,
  DEVICE_CONNECTION_ERROR_ICON,
  MAX_PROGRAM_ENROLMENT_IMAGE
} = HEALTH_PROGRAMS_ASSET_KEYS;
var HEALTH_PROGRAMS_ASSETS_MAP = {
  [STAR_RIBBON]: starRibbon,
  [SUCCESS_STATUS]: successStatus,
  [CONNECT_DEVICES]: connectDevices,
  [ENABLED_BADGE_PLACEHOLDER]: enabledBadgePlaceholder,
  [GARBAGE_ICON]: garbageIcon,
  [HELPFUL_TIP_FALL_BACK_IMAGE]: helpfulTipFallBackImage,
  [DEVICE_CONNECTION_ERROR_ICON]: iconPivot,
  [MAX_PROGRAM_ENROLMENT_IMAGE]: maxProgramEnrolmentImage,
  [CLOCK]: clock
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(HEALTH_PROGRAMS_ASSETS_MAP);
};

// src/routes.jsx
import React29, { useEffect as useEffect7, useState as useState6 } from "react";
import {
  isConfigSettled,
  isProduction,
  useConfigSelection
} from "@leagueplatform/core";
import { Routes, Route, useNavigate as useNavigate4, useParams as useParams4 } from "@leagueplatform/routing";
import { useFeatureFlagQuery as useFeatureFlagQuery10 } from "@leagueplatform/user-profile-api";

// src/pages/main/health-programs-page.component.jsx
import React10, { useState as useState2, useEffect as useEffect2 } from "react";
import { LinkLegacy as Link4 } from "@leagueplatform/routing";
import {
  PageHeaderBackground,
  BackButtonArrow as BackButtonArrow2
} from "@leagueplatform/web-common-components";
import { Flex as Flex5, Box as Box7, HeadingOne } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl5 } from "@leagueplatform/locales";
import {
  useDocumentTitle,
  useScrollTopOnLocationChange
} from "@leagueplatform/web-common";
import {
  ENABLE_CHALLENGES_WELLNESS_AND_REWARDS as ENABLE_CHALLENGES_WELLNESS_AND_REWARDS3,
  ENABLE_NEW_JOURNEY_EXPERIENCE as ENABLE_NEW_JOURNEY_EXPERIENCE3,
  JOURNEY_ROUTES as JOURNEY_ROUTES4,
  ProgramLimitModal
} from "@leagueplatform/health-journey-common";
import { useIsChallengesEnabled } from "@leagueplatform/challenges";
import { useFeatureFlagQuery as useFeatureFlagQuery5 } from "@leagueplatform/user-profile-api";

// src/utils/health-programs-curated-carousel-types.const.js
var CURATED_CAROUSEL_TYPES = {
  PROGRAMLIBRARY: "programLibrary",
  HOMEFEED: "homeFeed",
  FEATURED: "featured"
};

// src/pages/program-details/hooks/use-challenges-carousel.ts
import { useGetAllChallenges } from "@leagueplatform/challenges";
import { ENABLE_CHALLENGES_WELLNESS_AND_REWARDS } from "@leagueplatform/health-journey-common";
import { useFeatureFlagQuery } from "@leagueplatform/user-profile-api";

// src/utils/format-challenges-for-programs-cards.utils.ts
var formatChallengesForProgramCards = (challengesData) => {
  var _a;
  const formattedChallenges = (_a = challengesData.data) == null ? void 0 : _a.map((challenge) => {
    const {
      // eslint-disable-next-line @typescript-eslint/naming-convention -- FIXME: automatically added for existing issue
      id: program_id,
      title: name,
      // eslint-disable-next-line @typescript-eslint/naming-convention -- FIXME: automatically added for existing issue
      headerImageUrl: image_url = "",
      // eslint-disable-next-line @typescript-eslint/naming-convention -- FIXME: automatically added for existing issue
      startDate: start_date,
      // eslint-disable-next-line @typescript-eslint/naming-convention -- FIXME: automatically added for existing issue
      endDate: end_date,
      // eslint-disable-next-line @typescript-eslint/naming-convention -- FIXME: automatically added for existing issue
      startEnroll: start_enroll,
      // eslint-disable-next-line @typescript-eslint/naming-convention -- FIXME: automatically added for existing issue
      endEnroll: end_enroll,
      // eslint-disable-next-line @typescript-eslint/naming-convention -- FIXME: automatically added for existing issue
      challengeType: challenge_type,
      // eslint-disable-next-line @typescript-eslint/naming-convention -- FIXME: automatically added for existing issue
      totalActivities: total_activities_count
    } = challenge;
    return {
      program_id,
      name,
      image_url,
      challenge_info: {
        challenge_type,
        start_date,
        end_date,
        start_enroll,
        end_enroll
      },
      type: challenge.type,
      total_activities_count
    };
  });
  return formattedChallenges;
};

// src/pages/program-details/hooks/use-challenges-carousel.ts
var useChallengesCarousel = ({
  title,
  description
}) => {
  const { data: isChallengesWellnessAndRewardsEnabled } = useFeatureFlagQuery(
    ENABLE_CHALLENGES_WELLNESS_AND_REWARDS
  );
  const { data: challengeData, isLoading, isError } = useGetAllChallenges();
  const programs = (challengeData == null ? void 0 : challengeData.data.length) ? formatChallengesForProgramCards(challengeData) : [];
  const firstThreeChallenges = programs.slice(0, 3);
  return {
    ready: !isLoading,
    hasError: isError,
    carousels: [
      {
        id: null,
        title,
        description,
        programs: isChallengesWellnessAndRewardsEnabled ? firstThreeChallenges : programs
      }
    ]
  };
};

// src/pages/main/hooks/use-health-programs.hook.js
import { useQuery } from "@tanstack/react-query";
import {
  GET_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE,
  getHealthGoalPrograms
} from "@leagueplatform/health-journey-api";
var useHealthGoalPrograms = () => useQuery([GET_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE], getHealthGoalPrograms);

// src/pages/main/hooks/use-health-program-categories.hook.js
import { useQuery as useQuery2 } from "@tanstack/react-query";
import {
  GET_HEALTH_PROGRAM_CATEGORIES_MESSAGE_TYPE,
  getHealthProgramCategories
} from "@leagueplatform/health-journey-api";

// src/utils/filter-and-sort-objects-by-key.utils.js
var alphaSortObjectsByStringValue = (array, property) => array.filter((obj) => {
  var _a;
  return Boolean((obj == null ? void 0 : obj[property]) && ((_a = obj == null ? void 0 : obj[property]) == null ? void 0 : _a.trim()));
}).sort((a, b) => a[property].localeCompare(b[property]));

// src/pages/main/hooks/use-health-program-categories.hook.js
var useHealthProgramCategories = () => useQuery2(
  [GET_HEALTH_PROGRAM_CATEGORIES_MESSAGE_TYPE],
  getHealthProgramCategories,
  {
    select(data) {
      const { title, categories } = data;
      const sortedCategories = alphaSortObjectsByStringValue(
        categories,
        "name"
      );
      return { title, categories: sortedCategories };
    }
  }
);

// src/hooks/use-health-program-curated-carousels.hook.js
import { useQuery as useQuery3 } from "@tanstack/react-query";
import {
  getHealthProgramCuratedCarousels,
  GET_HEALTH_PROGRAM_CURATED_CAROUSELS_MESSAGE_TYPE
} from "@leagueplatform/health-journey-api";
var useHealthProgramCuratedCarousels = (type) => useQuery3(
  [GET_HEALTH_PROGRAM_CURATED_CAROUSELS_MESSAGE_TYPE, type],
  () => getHealthProgramCuratedCarousels(type)
);

// src/hooks/use-health-program-suggested-carousels.hook.js
import { useQuery as useQuery4 } from "@tanstack/react-query";
import {
  getHealthProgramSuggestedCarousels,
  GET_HEALTH_PROGRAM_SUGGESTED_CAROUSELS_MESSAGE_TYPE
} from "@leagueplatform/health-journey-api";
var useHealthProgramSuggestedCarousels = () => useQuery4(
  [GET_HEALTH_PROGRAM_SUGGESTED_CAROUSELS_MESSAGE_TYPE],
  getHealthProgramSuggestedCarousels
);

// src/hooks/use-program-library-analytics.hook.tsx
import {
  trackAnalyticsEvent,
  EVENT_NAME,
  PRODUCT_AREA
} from "@leagueplatform/analytics";
import { SCREEN_NAMES } from "@leagueplatform/health-journey-common";

// src/hooks/use-active-campaign-limit-info.hook.js
import { useQuery as useQuery5 } from "@tanstack/react-query";
import {
  GET_ACTIVE_CAMPAIGN_LIMIT_INFO_MESSAGE_TYPE,
  getActiveCampaignLimitInfo
} from "@leagueplatform/health-journey-api";
var useActiveCampaignInfo = () => useQuery5(
  [GET_ACTIVE_CAMPAIGN_LIMIT_INFO_MESSAGE_TYPE],
  getActiveCampaignLimitInfo,
  { staleTime: Infinity }
);

// src/hooks/use-program-library-analytics.hook.tsx
var { SCREEN_LOADED, BUTTON_CLICKED } = EVENT_NAME;
var useProgramLibraryAnalytics = () => {
  const { data: campaignLimitInfo = {} } = useActiveCampaignInfo();
  const {
    number_of_enrolled_programs: activeCampaigns,
    max_programs_limit: campaignLimit
  } = campaignLimitInfo;
  const meta = {
    product_area: PRODUCT_AREA.JOURNEY,
    screen_name: SCREEN_NAMES.PROGRAM_LIBRARY
  };
  const data = {
    num_health_campaign_active: activeCampaigns != null ? activeCampaigns : null,
    num_health_campaign_limit: campaignLimit != null ? campaignLimit : null
  };
  return {
    sendViewProgramLibrary() {
      trackAnalyticsEvent(SCREEN_LOADED, __spreadValues(__spreadValues({}, meta), data));
    },
    sendSelectProgram({
      carouselName,
      carouselIndex,
      programCategory,
      pageContext,
      program,
      metricType,
      isChallenge
    }) {
      const { program_id: programId, name } = program;
      trackAnalyticsEvent(BUTTON_CLICKED, __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, meta), data), metricType && {
        metric_type: metricType,
        health_campaign_type: isChallenge ? "challenge" : "opt-in"
      }), {
        screen_name: pageContext,
        detail: "view health campaign",
        health_campaign_id: programId,
        health_campaign_name: name,
        carousel_name: carouselName,
        carousel_index: carouselIndex,
        health_campaign_category: programCategory
      }));
    },
    sendSelectProgramCategory(category) {
      trackAnalyticsEvent(BUTTON_CLICKED, __spreadProps(__spreadValues({}, meta), {
        detail: "view health campaign category",
        health_campaign_category: category
      }));
    },
    sendViewProgramCategory(category) {
      trackAnalyticsEvent(SCREEN_LOADED, __spreadProps(__spreadValues({}, meta), {
        screen_name: SCREEN_NAMES.CATEGORY_PAGE,
        health_campaign_category: category
      }));
    },
    sendLeaveProgramCategory(category) {
      trackAnalyticsEvent(BUTTON_CLICKED, __spreadProps(__spreadValues({}, meta), {
        screen_name: SCREEN_NAMES.CATEGORY_PAGE,
        detail: "close",
        health_campaign_category: category
      }));
    }
  };
};

// src/pages/main/components/health-program-error-state/health-program-error-state.component.jsx
import React from "react";
import PropTypes from "prop-types";
import { LinkLegacy as Link } from "@leagueplatform/routing";
import { Flex, Box } from "@leagueplatform/genesis-commons";
import {
  BackButtonArrow,
  ErrorState
} from "@leagueplatform/web-common-components";
import { JOURNEY_ROUTES } from "@leagueplatform/health-journey-common";
var HealthProgramErrorState = ({ error }) => /* @__PURE__ */ React.createElement(
  Flex,
  {
    padding: { _: "oneAndHalf", phone: "twoAndHalf" },
    flexDirection: { _: "column", phone: "row" },
    margin: "0 auto",
    justifyContent: "center"
  },
  /* @__PURE__ */ React.createElement(
    BackButtonArrow,
    {
      as: Link,
      color: "onSurface.text.primary",
      fontSize: "heading3",
      marginInlineEnd: "one",
      marginY: "half",
      to: JOURNEY_ROUTES.journeyHome
    }
  ),
  /* @__PURE__ */ React.createElement(Box, { marginTop: "three" }, /* @__PURE__ */ React.createElement(ErrorState, { error }))
);
HealthProgramErrorState.propTypes = {
  error: PropTypes.shape({})
};
HealthProgramErrorState.defaultProps = {
  error: {}
};

// src/pages/main/components/health-program-categories/health-program-categories.component.tsx
import React3 from "react";
import { SkeletonBox } from "@leagueplatform/web-common-components";
import { useTheme } from "@leagueplatform/genesis-commons";
import { ENABLE_NEW_JOURNEY_EXPERIENCE } from "@leagueplatform/health-journey-common";
import { useFeatureFlagQuery as useFeatureFlagQuery2 } from "@leagueplatform/user-profile-api";
import { Box as Box3, HeadingText } from "@leagueplatform/genesis-core";

// src/pages/main/components/activity-container/activity-container.component.js
import { Box as Box2, genesisStyled } from "@leagueplatform/genesis-commons";
var ActivityContainer = genesisStyled(Box2)`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(275px, 1fr));
  grid-auto-rows: 1fr;
  grid-row-gap: ${({ theme }) => theme.space.one}px;
  grid-column-gap: ${({ theme }) => theme.space.oneAndHalf}px;
`;

// src/pages/main/components/health-program-categories/category-card.component.tsx
import {
  Card,
  Icon,
  StackLayout,
  TextAction,
  useClickableCard
} from "@leagueplatform/genesis-core";
import { JOURNEY_ROUTES as JOURNEY_ROUTES2 } from "@leagueplatform/health-journey-common";
import { LinkLegacy as Link2 } from "@leagueplatform/routing";
import React2 from "react";
function CategoryCard({ categoryId, name, iconUrl }) {
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard();
  const programLibraryAnalytics = useProgramLibraryAnalytics();
  return /* @__PURE__ */ React2.createElement("li", { key: categoryId }, /* @__PURE__ */ React2.createElement(Card.Elevated, { backgroundColor: "secondary", css: { height: "100%" } }, /* @__PURE__ */ React2.createElement(
    Card.ClickArea,
    {
      ref: clickAreaRef,
      onCardMouseUp,
      onCardMouseDown,
      css: {
        width: "100%",
        height: "100%",
        display: "block",
        "&:hover": {
          backgroundColor: "surface.background.secondary",
          textDecoration: "none !important"
        },
        "&:focus": {
          backgroundColor: "interactive.action.disabled"
        }
      }
    },
    /* @__PURE__ */ React2.createElement(
      StackLayout,
      {
        orientation: "horizontal",
        horizontalAlignment: "start",
        verticalAlignment: "center",
        spacing: "$half",
        css: {
          width: "100%",
          height: "100%",
          paddingY: "$oneAndHalf",
          paddingX: "$one"
        }
      },
      /* @__PURE__ */ React2.createElement(Icon, { icon: iconUrl, label: "", size: "$two" }),
      /* @__PURE__ */ React2.createElement(
        TextAction,
        {
          ref: primaryActionRef,
          as: Link2,
          to: JOURNEY_ROUTES2.getProgramCategory(categoryId),
          onClick: () => {
            programLibraryAnalytics.sendSelectProgramCategory(name);
          },
          css: {
            typography: "$headingThree",
            fontFamily: "$headings",
            color: "$interactiveActionSubdued"
          }
        },
        name
      )
    )
  )));
}
var category_card_component_default = CategoryCard;

// src/pages/main/components/health-program-categories/health-program-categories.component.tsx
var HealthProgramCategories = () => {
  var _a;
  const { data: isNewJourneyExperienceEnabled } = useFeatureFlagQuery2(
    ENABLE_NEW_JOURNEY_EXPERIENCE
  );
  const { data, isLoading } = useHealthProgramCategories();
  const theme = useTheme();
  if (isLoading)
    return /* @__PURE__ */ React3.createElement(
      SkeletonBox,
      {
        height: "200px",
        width: "100%",
        marginBottom: theme.space.twoAndHalf
      }
    );
  return (data == null ? void 0 : data.categories) && /* @__PURE__ */ React3.createElement(Box3, { css: { paddingBottom: "$four" } }, /* @__PURE__ */ React3.createElement(
    HeadingText,
    {
      level: "2",
      size: "xl",
      css: { marginBottom: "$four" },
      as: isNewJourneyExperienceEnabled ? "h3" : "h2"
    },
    data == null ? void 0 : data.title
  ), /* @__PURE__ */ React3.createElement(ActivityContainer, { as: "ul" }, (_a = data == null ? void 0 : data.categories) == null ? void 0 : _a.map(({ name, icon_url: iconUrl, id }) => /* @__PURE__ */ React3.createElement(
    category_card_component_default,
    {
      key: id,
      categoryId: id,
      name,
      iconUrl
    }
  ))));
};

// src/pages/main/components/health-goal-programs/health-goal-programs.component.jsx
import React6, { useMemo, useState, useRef as useRef2, useEffect } from "react";
import sortBy from "lodash/sortBy";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import { SkeletonBox as SkeletonBox2 } from "@leagueplatform/web-common-components";
import {
  HeadingTwo,
  Flex as Flex2,
  useTheme as useTheme2,
  SubtleButton
} from "@leagueplatform/genesis-commons";

// src/components/health-programs-gallery.component.jsx
import React5, { forwardRef as forwardRef2 } from "react";
import { string as string2, shape as shape2, number as number2 } from "prop-types";
import { Box as Box5 } from "@leagueplatform/genesis-core";

// src/components/health-programs-card.component.tsx
import React4, { useRef, forwardRef } from "react";
import { useIntl } from "@leagueplatform/locales";
import { LinkLegacy as LinkDOM } from "@leagueplatform/routing";
import {
  SubtitleOne,
  BodyTwo,
  BodyOneSecondary,
  Overline,
  CoverImage,
  Box as Box4
} from "@leagueplatform/genesis-commons";
import { TextAction as TextAction2 } from "@leagueplatform/genesis-core";
import { ConditionalLinkCard } from "@leagueplatform/web-common-components";
import { useGetUserProfile } from "@leagueplatform/web-common";
import { JOURNEY_ROUTES as JOURNEY_ROUTES3 } from "@leagueplatform/health-journey-common";

// src/components/health-programs-card.utils.tsx
import {
  isBeforeEnrollmentPeriod,
  isEnrollmentOpen
} from "@leagueplatform/challenges";
import { arrayToTag, SHORT_DATE_FORMAT } from "@leagueplatform/web-common";
var getHealthContents = (program, formatMessage, formatNumber) => {
  const {
    description,
    available_points: availablePoints,
    total_activities_count: total
  } = program;
  const caption = arrayToTag([
    `${total} ${formatMessage(
      { id: "ACTIVITIES_PLURALIZATION" },
      { count: total }
    ).toLowerCase()}`,
    availablePoints ? formatMessage(
      { id: "VAL_POINTS" },
      {
        points: formatNumber(availablePoints, { style: "decimal" })
      }
    ) : null
  ]);
  return {
    caption,
    description
  };
};
var getChallengeContents = (program, formatMessage, formatDate, defaultTimezone) => {
  const {
    total_activities_count: totalActivities,
    challenge_info: {
      challenge_type: challengeType,
      start_enroll: startEnroll,
      end_enroll: endEnroll,
      start_date: startDate,
      end_date: endDate
    }
  } = program;
  const isGroupChallenge = challengeType !== "solo";
  let signUpText = formatMessage({ id: "SIGN_UP_DATE_PASSED" });
  const isAllProgramsCard = startDate.charAt(startDate.length - 1) === "Z";
  const dateFormatOptions = __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT), {
    timeZone: isAllProgramsCard ? "UTC" : defaultTimezone
  });
  if (startEnroll && isBeforeEnrollmentPeriod(startEnroll, defaultTimezone)) {
    signUpText = formatMessage(
      { id: "SIGN_UP_BEGINS_DATE" },
      {
        date: formatDate(startEnroll, dateFormatOptions)
      }
    );
  }
  if (startEnroll && isEnrollmentOpen(startEnroll, endEnroll, defaultTimezone)) {
    signUpText = formatMessage(
      { id: "SIGN_UP_BY" },
      {
        date: formatDate(endEnroll, dateFormatOptions)
      }
    );
  }
  const caption = isGroupChallenge ? signUpText : `${totalActivities} ${formatMessage(
    { id: "ACTIVITIES_PLURALIZATION" },
    { count: totalActivities }
  ).toLowerCase()}`;
  const description = isGroupChallenge && formatMessage(
    { id: "START_AND_END_DATES" },
    {
      startDate: formatDate(startDate, dateFormatOptions),
      endDate: formatDate(endDate, dateFormatOptions)
    }
  );
  return {
    caption,
    description
  };
};
function isProgramAChallenge(program) {
  return program.challenge_info !== void 0 && program.challenge_info !== null;
}
var PROGRAM_TYPE = "program";
var getProgramType = (program) => {
  var _a;
  return ((_a = program == null ? void 0 : program.challenge_info) == null ? void 0 : _a.challenge_type) || PROGRAM_TYPE;
};

// src/components/health-programs-card.component.tsx
var HealthProgramsCard = forwardRef(
  ({
    tag = null,
    analyticsContext = {
      carouselName: null,
      carouselIndex: null,
      programCategory: null,
      pageContext: void 0
    },
    program,
    badgeComponent: BadgeComponent
  }, ref) => {
    const { formatDate, formatMessage, formatNumber } = useIntl();
    const programLibraryAnalytics = useProgramLibraryAnalytics();
    const linkRef = useRef(null);
    const { data: userData } = useGetUserProfile({ staleTime: Infinity });
    const { defaultTimezone } = userData || {};
    const { name, program_id: programId, image_url: imageUrl } = program;
    const isChallenge = isProgramAChallenge(program);
    const { description, caption } = isChallenge ? getChallengeContents(
      program,
      formatMessage,
      formatDate,
      defaultTimezone
    ) : getHealthContents(program, formatMessage, formatNumber);
    const getLinkPath = () => isChallenge ? JOURNEY_ROUTES3.getChallengeDetails(programId) : JOURNEY_ROUTES3.getProgramDetails(programId);
    const programType = getProgramType(program);
    return /* @__PURE__ */ React4.createElement(
      ConditionalLinkCard,
      {
        hasLink: true,
        linkRef,
        cardStyle: {
          // adding ts-ignore since we need to override the original boxShadow value for ConditionalLinkCard and ShadowPropsType doesn't include 'none'
          // @ts-ignore
          boxShadow: "none"
        }
      },
      /* @__PURE__ */ React4.createElement(
        Box4,
        {
          ref,
          position: "relative",
          flexDirection: "column",
          justifyContent: "center",
          paddingY: "half",
          width: { _: 155, phone: 299, laptop: 384 },
          maxWidth: "100%",
          marginTop: "one",
          marginBottom: "two"
        },
        /* @__PURE__ */ React4.createElement(
          CoverImage,
          {
            src: imageUrl,
            alt: "",
            width: "100%",
            maxWidth: "100%",
            height: { _: 111, phone: 190, laptop: 235 },
            borderRadius: "medium",
            marginBottom: "one",
            backgroundColor: "surface.background.secondary",
            position: "relative"
          }
        ),
        tag && !BadgeComponent && /* @__PURE__ */ React4.createElement(Overline, { as: "p", color: "onSurface.text.subdued" }, tag),
        BadgeComponent && /* @__PURE__ */ React4.createElement(BadgeComponent, { programType }),
        /* @__PURE__ */ React4.createElement(SubtitleOne, { as: "h3" }, /* @__PURE__ */ React4.createElement(
          TextAction2,
          {
            ref: linkRef,
            as: LinkDOM,
            to: getLinkPath(),
            css: {
              color: "$onSurfaceTextPrimary",
              fontWeight: "inherit",
              fontSize: "inherit",
              "&&:focus": {
                outline: "none"
              }
            },
            onClick: () => programLibraryAnalytics.sendSelectProgram(__spreadProps(__spreadValues({}, analyticsContext), {
              isChallenge,
              program
            }))
          },
          name
        )),
        /* @__PURE__ */ React4.createElement(BodyTwo, { color: "onSurface.text.primary", paddingBottom: "half" }, caption),
        /* @__PURE__ */ React4.createElement(
          BodyOneSecondary,
          {
            marginTop: "quarter",
            display: { _: "none", phone: "block" }
          },
          description
        )
      )
    );
  }
);

// src/utils/health-programs-page.props.js
import { bool, string, number, shape, arrayOf } from "prop-types";
var programsListItemPropType = {
  available_points: number,
  description: string,
  image_url: string,
  name: string,
  program_id: string,
  total_days: number,
  total_activities_count: number
};
var programsListPropType = arrayOf(shape(programsListItemPropType));
var programsBasePropTypes = {
  ready: bool,
  name: string,
  programs: programsListPropType
};
var programsPropTypes = shape(__spreadProps(__spreadValues({}, programsBasePropTypes), {
  hasError: bool,
  numberOfAvailablePrograms: number,
  programLimitModal: shape({
    title: string,
    description: string
  })
}));

// src/components/health-programs-gallery.component.jsx
var HealthProgramsGallery = forwardRef2(
  ({ programs, analyticsContext, firstNewProgramIndex }, ref) => /* @__PURE__ */ React5.createElement(Box5, { css: { display: "flex", flexWrap: "wrap" }, as: "ul" }, programs.length > 0 && programs.map((program, index) => {
    const isFirstNewProgram = index === firstNewProgramIndex;
    return /* @__PURE__ */ React5.createElement(
      Box5,
      {
        as: "li",
        key: program.program_id,
        css: {
          width: "fit-content",
          margin: "$threeQuarters"
        }
      },
      /* @__PURE__ */ React5.createElement(
        HealthProgramsCard,
        {
          program,
          analyticsContext,
          ref: isFirstNewProgram ? ref : void 0
        }
      )
    );
  }))
);
HealthProgramsGallery.propTypes = {
  programs: programsListPropType,
  analyticsContext: shape2({ programCategory: string2, pageContext: string2 }),
  firstNewProgramIndex: number2.isRequired
};
HealthProgramsGallery.defaultProps = {
  programs: [],
  analyticsContext: {
    pageContext: void 0,
    programCategory: void 0
  }
};

// src/pages/main/components/health-goal-programs/health-goal-programs.component.jsx
var HealthGoalPrograms = () => {
  const { formatMessage } = useIntl2();
  const { data, isLoading } = useHealthGoalPrograms();
  const programCardRef = useRef2(null);
  const sortedProgramsListByName = sortBy(data == null ? void 0 : data.programs, "name");
  const initialVisibleProgramsLength = 12;
  const isProgramsListGreaterThanTwelve = (sortedProgramsListByName == null ? void 0 : sortedProgramsListByName.length) > initialVisibleProgramsLength;
  const [numOfVisiblePrograms, setNumOfVisiblePrograms] = useState(
    initialVisibleProgramsLength
  );
  const [firstNewProgramIndex, setFirstNewProgramIndex] = useState(numOfVisiblePrograms);
  const visibleHealthPrograms = useMemo(
    () => sortedProgramsListByName == null ? void 0 : sortedProgramsListByName.slice(0, numOfVisiblePrograms),
    [sortedProgramsListByName, numOfVisiblePrograms]
  );
  const isAllProgramsDisplayed = (visibleHealthPrograms == null ? void 0 : visibleHealthPrograms.length) === (sortedProgramsListByName == null ? void 0 : sortedProgramsListByName.length);
  useEffect(() => {
    var _a;
    (_a = programCardRef == null ? void 0 : programCardRef.current) == null ? void 0 : _a.focus();
  }, [programCardRef, numOfVisiblePrograms]);
  const theme = useTheme2();
  if (isLoading)
    return /* @__PURE__ */ React6.createElement(
      SkeletonBox2,
      {
        height: "600px",
        width: "100%",
        marginBottom: theme.space.twoAndHalf
      }
    );
  return (visibleHealthPrograms == null ? void 0 : visibleHealthPrograms.length) > 0 && /* @__PURE__ */ React6.createElement(Flex2, { flexDirection: "column" }, /* @__PURE__ */ React6.createElement(HeadingTwo, { paddingBottom: "half", fontSize: { phone: "heading2" } }, data == null ? void 0 : data.name), /* @__PURE__ */ React6.createElement("div", { "aria-live": "polite" }, /* @__PURE__ */ React6.createElement(
    HealthProgramsGallery,
    {
      programs: visibleHealthPrograms,
      firstNewProgramIndex,
      ref: programCardRef
    }
  )), isProgramsListGreaterThanTwelve && !isAllProgramsDisplayed && /* @__PURE__ */ React6.createElement(
    SubtleButton,
    {
      marginTop: "twoAndHalf",
      width: "166px",
      alignSelf: "center",
      onClick: () => {
        setNumOfVisiblePrograms(
          numOfVisiblePrograms + initialVisibleProgramsLength
        );
        setFirstNewProgramIndex(numOfVisiblePrograms);
      }
    },
    formatMessage({ id: "SHOW_MORE" })
  ), isAllProgramsDisplayed && isProgramsListGreaterThanTwelve && /* @__PURE__ */ React6.createElement(
    SubtleButton,
    {
      marginTop: "twoAndHalf",
      width: "166px",
      alignSelf: "center",
      onClick: () => {
        setNumOfVisiblePrograms(initialVisibleProgramsLength);
      }
    },
    formatMessage({ id: "SHOW_LESS" })
  ));
};

// src/components/health-program-carousels.component.jsx
import React8 from "react";
import PropTypes3 from "prop-types";
import {
  BodyOneSecondary as BodyOneSecondary2,
  HeadingTwo as HeadingTwo2,
  useTheme as useTheme3
} from "@leagueplatform/genesis-commons";
import { SkeletonBox as SkeletonBox3 } from "@leagueplatform/web-common-components";
import { useFeatureFlagQuery as useFeatureFlagQuery4 } from "@leagueplatform/user-profile-api";
import { ENABLE_NEW_JOURNEY_EXPERIENCE as ENABLE_NEW_JOURNEY_EXPERIENCE2 } from "@leagueplatform/health-journey-common";

// src/components/health-programs-list.component.jsx
import React7 from "react";
import PropTypes2, { shape as shape3, string as string3 } from "prop-types";
import { useFeatureFlagQuery as useFeatureFlagQuery3 } from "@leagueplatform/user-profile-api";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import { uniqueId, get, find } from "lodash";
import { arrayToTag as arrayToTag2 } from "@leagueplatform/web-common";
import { Box as Box6, Flex as Flex3 } from "@leagueplatform/genesis-commons";
import { Carousel } from "@leagueplatform/web-common-components";
import {
  CHALLENGE,
  ENABLE_CHALLENGES_WELLNESS_AND_REWARDS as ENABLE_CHALLENGES_WELLNESS_AND_REWARDS2
} from "@leagueplatform/health-journey-common";
import { sendAnalyticsEvent } from "@leagueplatform/analytics";
var HealthProgramsList = ({
  data,
  title,
  description,
  sortKey,
  id,
  hideTag,
  categories,
  showProgramDescription,
  analyticsContext,
  linkCta,
  linkUrl
}) => {
  const { $tmap } = useIntl3();
  const { data: isChallengesWellnessAndRewardsEnabled } = useFeatureFlagQuery3(
    ENABLE_CHALLENGES_WELLNESS_AND_REWARDS2
  );
  const sortCallback = (a, b) => a[sortKey] - b[sortKey];
  const RightNavButtonAnalyticsFn = () => {
    sendAnalyticsEvent({
      category: analyticsContext == null ? void 0 : analyticsContext.pageContext,
      action: "Scroll Carousel",
      params: {
        carousel_name: analyticsContext == null ? void 0 : analyticsContext.carouselName
      }
    });
  };
  const challengeTypeMap = $tmap({
    solo: "SOLO_CHALLENGE",
    group: "GROUP_CHALLENGE"
  });
  return (data == null ? void 0 : data.length) > 0 && /* @__PURE__ */ React7.createElement(
    Flex3,
    {
      id,
      marginBottom: "one",
      maxWidth: {
        _: "345px",
        phone: "640px",
        laptop: "895px",
        desktop: "1210px"
      }
    },
    /* @__PURE__ */ React7.createElement(
      Carousel,
      {
        heading: title,
        description,
        name: "health-programs-list",
        RightNavButtonAnalyticsFn,
        linkCta,
        linkUrl
      },
      data.sort(sortCallback).map((item, index) => {
        var _a;
        const tags = (_a = (item == null ? void 0 : item.tag) || (item == null ? void 0 : item.categories)) != null ? _a : [];
        const categoryTag = tags.map((tag) => {
          const programCategory = find(
            categories,
            (category) => category.id === tag
          );
          return get(programCategory, "name", "");
        });
        const showChallengeTag = item.type === CHALLENGE && item.challenge_info.challenge_type && isChallengesWellnessAndRewardsEnabled;
        return /* @__PURE__ */ React7.createElement(
          Box6,
          {
            marginInlineEnd: "half",
            key: uniqueId("health-program-card-", item.programId)
          },
          /* @__PURE__ */ React7.createElement(
            HealthProgramsCard,
            {
              program: item,
              analyticsContext: __spreadProps(__spreadValues({}, analyticsContext), {
                carouselIndex: index
              }),
              tag: showChallengeTag ? challengeTypeMap(item.challenge_info.challenge_type) : !hideTag && arrayToTag2(categoryTag),
              description: showProgramDescription ? item.description : null
            }
          )
        );
      })
    )
  );
};
HealthProgramsList.propTypes = {
  data: programsListPropType,
  title: PropTypes2.node,
  description: PropTypes2.node,
  sortKey: PropTypes2.string,
  id: PropTypes2.string,
  hideTag: PropTypes2.bool,
  categories: PropTypes2.arrayOf(
    PropTypes2.shape({
      id: PropTypes2.string.isRequired,
      name: PropTypes2.string.isRequired,
      description: PropTypes2.string.isRequired,
      sortOrder: PropTypes2.number.isRequired
    })
  ),
  showProgramDescription: PropTypes2.bool,
  analyticsContext: shape3({ carouselName: string3, pageContext: string3 }),
  linkCta: PropTypes2.string,
  linkUrl: PropTypes2.string
};
HealthProgramsList.defaultProps = {
  data: [],
  sortKey: null,
  id: "",
  hideTag: false,
  title: "",
  description: "",
  categories: [],
  showProgramDescription: true,
  analyticsContext: {
    pageContext: void 0,
    carouselName: ""
  },
  linkCta: "",
  linkUrl: ""
};

// src/components/health-program-carousels.component.jsx
var HealthProgramCarousels = ({
  // eslint-disable-next-line react/prop-types -- FIXME: automatically added for existing issue
  isLoading,
  hideLoadingSkeleton,
  carousels,
  carouselsCategory,
  linkCta,
  linkUrl
}) => {
  const { data: isNewJourneyExperienceEnabled } = useFeatureFlagQuery4(
    ENABLE_NEW_JOURNEY_EXPERIENCE2
  );
  const theme = useTheme3();
  if (!carousels)
    return null;
  if (hideLoadingSkeleton && isLoading) {
    return null;
  }
  if (isLoading) {
    return /* @__PURE__ */ React8.createElement(
      SkeletonBox3,
      {
        height: "300px",
        marginBottom: theme.space.twoAndHalf,
        width: "100%"
      }
    );
  }
  return carousels == null ? void 0 : carousels.map(({ title, description, programs, analyticsProps }) => {
    const titleView = /* @__PURE__ */ React8.createElement(
      HeadingTwo2,
      {
        paddingBottom: "half",
        as: isNewJourneyExperienceEnabled ? "h3" : "h2"
      },
      title
    );
    const descriptionView = /* @__PURE__ */ React8.createElement(BodyOneSecondary2, null, description);
    return /* @__PURE__ */ React8.createElement(
      HealthProgramsList,
      {
        data: programs,
        description: descriptionView,
        key: title,
        title: titleView,
        analyticsContext: __spreadProps(__spreadValues({}, analyticsProps), {
          pageContext: carouselsCategory,
          carouselName: title
        }),
        linkCta,
        linkUrl
      }
    );
  });
};
HealthProgramCarousels.propTypes = {
  carousels: PropTypes3.arrayOf(
    PropTypes3.shape({
      title: PropTypes3.string,
      description: PropTypes3.string,
      programs: programsListPropType,
      analyticsProps: PropTypes3.objectOf(PropTypes3.string)
    })
  ),
  carouselsCategory: PropTypes3.string,
  // eslint-disable-next-line react/no-unused-prop-types -- FIXME: automatically added for existing issue
  ready: PropTypes3.bool,
  linkCta: PropTypes3.string,
  linkUrl: PropTypes3.string,
  hideLoadingSkeleton: PropTypes3.bool
};
HealthProgramCarousels.defaultProps = {
  carousels: [],
  carouselsCategory: "",
  ready: false,
  linkCta: "",
  linkUrl: "",
  hideLoadingSkeleton: false
};

// src/pages/main/components/program-limit-reached-component/program-limit-reached.component.jsx
import React9 from "react";
import PropTypes4 from "prop-types";
import { useIntl as useIntl4 } from "@leagueplatform/locales";
import { genesisFocus } from "@leagueplatform/ui-kit";
import {
  BodyOneSecondary as BodyOneSecondary3,
  CoverImage as CoverImage2,
  SubtitleOne as SubtitleOne2,
  BodyOne,
  Flex as Flex4,
  Link as Link3,
  genesisStyled as genesisStyled2
} from "@leagueplatform/genesis-commons";
import { handleStaticAsset } from "@leagueplatform/asset-config";

// src/pages/main/utils/on-click-banner-actions.js
import {
  PRODUCT_AREA as PRODUCT_AREA2,
  trackAnalyticsEvent as trackAnalyticsEvent2,
  EVENT_NAME as EVENT_NAME2
} from "@leagueplatform/analytics";
var onClickBannerActions = (setShowProgramLimitModel) => {
  setShowProgramLimitModel(true);
  trackAnalyticsEvent2(EVENT_NAME2.BUTTON_CLICKED, {
    product_area: PRODUCT_AREA2.JOURNEY,
    screen_name: "health campaign library",
    detail: "view health campaign limit banner"
  });
};

// src/pages/main/components/program-limit-reached-component/program-limit-reached.component.jsx
var StyledFlexLink = genesisStyled2(Flex4)`
  &:hover, &:focus {
    text-decoration: none;
    .pseudo-link {
      text-decoration: underline;
    }
  }
`;
var ProgramLimitReached = ({ setShowProgramLimitModel }) => {
  const maxProgramEnrolmentImage2 = handleStaticAsset(
    "MAX_PROGRAM_ENROLMENT_IMAGE" /* MAX_PROGRAM_ENROLMENT_IMAGE */
  );
  const { formatMessage } = useIntl4();
  return /* @__PURE__ */ React9.createElement(
    StyledFlexLink,
    {
      flexDirection: { _: "column", phone: "row" },
      as: Link3,
      href: "#",
      padding: "oneAndHalf",
      marginBottom: "three",
      backgroundColor: "surface.background.secondary",
      alignItems: "center",
      onClick: (e) => {
        e.preventDefault();
        onClickBannerActions(setShowProgramLimitModel);
      },
      focusStyle: genesisFocus,
      cursor: "pointer"
    },
    /* @__PURE__ */ React9.createElement(
      CoverImage2,
      {
        src: maxProgramEnrolmentImage2,
        alt: "",
        size: 47,
        marginInlineEnd: "oneAndHalf"
      }
    ),
    /* @__PURE__ */ React9.createElement(Flex4, { flexDirection: "column" }, /* @__PURE__ */ React9.createElement(SubtitleOne2, { as: "h2", marginBottom: "quarter" }, formatMessage({ id: "LOOKS_LIKE_REACHED_PROGRAM_LIMIT" })), /* @__PURE__ */ React9.createElement(BodyOneSecondary3, null, formatMessage(
      {
        id: "COMPLETE_ACTIVE_PROGRAM_BEFORE_NEW_ONE"
      },
      {
        ctaText: formatMessage({ id: "LEARN_MORE" }),
        // eslint-disable-next-line react/no-unstable-nested-components -- FIXME: automatically added for existing issue
        strong: (msg) => /* @__PURE__ */ React9.createElement(
          BodyOne,
          {
            as: "strong",
            color: "interactive.action.primary",
            fontWeight: "bold"
          },
          msg
        )
      }
    )))
  );
};
ProgramLimitReached.propTypes = {
  setShowProgramLimitModel: PropTypes4.func.isRequired
};

// src/pages/main/health-programs-page.component.jsx
var HealthProgramsPage = () => {
  var _a, _b, _c;
  useScrollTopOnLocationChange();
  const { formatMessage } = useIntl5();
  useDocumentTitle(formatMessage({ id: "HEALTH_PROGRAMS" }));
  const {
    isError: healthProgramsError,
    data: healthProgramsData,
    error: healthProgramsErrorType
  } = useHealthGoalPrograms();
  const {
    data: healthProgramCategoriesData,
    isError: healthProgramCategoriesError,
    error: healthProgramCategoriesErrorType
  } = useHealthProgramCategories();
  const {
    data: healthProgramCuratedCarouselsData,
    isError: healthProgramCuratedCarouselsError,
    isLoading: isHealthProgramCuratedCarouselsLoading,
    error: healthProgramCuratedCarouselsErrorType
  } = useHealthProgramCuratedCarousels(CURATED_CAROUSEL_TYPES.PROGRAMLIBRARY);
  const {
    data: healthProgramSuggestedCarouselsData,
    isError: healthProgramSuggestedCarouselsError,
    isLoading: isHealthProgramSuggestedCarouselsLoading,
    error: healthProgramSuggestedCarouselsErrorType
  } = useHealthProgramSuggestedCarousels();
  const { data: isNewJourneyExperienceEnabled } = useFeatureFlagQuery5(
    ENABLE_NEW_JOURNEY_EXPERIENCE3
  );
  const { data: isChallengesWellnessAndRewardsEnabled } = useFeatureFlagQuery5(
    ENABLE_CHALLENGES_WELLNESS_AND_REWARDS3
  );
  const programLibraryAnalytics = useProgramLibraryAnalytics();
  useEffect2(() => {
    programLibraryAnalytics.sendViewProgramLibrary();
  }, []);
  const [showProgramLimitModel, setShowProgramLimitModel] = useState2(false);
  const { isChallengesEnabled } = useIsChallengesEnabled();
  const errors = [
    healthProgramSuggestedCarouselsErrorType,
    healthProgramCuratedCarouselsErrorType,
    healthProgramCategoriesErrorType,
    healthProgramsErrorType
  ];
  const {
    ready: isChallengeHealthProgramReady,
    carousels: challengeHealthProgramCarousels,
    hasError: isChallengeHealthProgramError
  } = useChallengesCarousel({
    title: formatMessage({ id: "CHALLENGES" }),
    description: formatMessage({
      id: "CHALLENGE_PROGRAM_LIBRARY_DESCRIPTION"
    })
  });
  if (healthProgramsError && healthProgramCategoriesError && isChallengeHealthProgramError && healthProgramCuratedCarouselsError && healthProgramSuggestedCarouselsError) {
    return /* @__PURE__ */ React10.createElement(HealthProgramErrorState, { error: errors });
  }
  const isProgramLimitReached = (healthProgramsData == null ? void 0 : healthProgramsData.number_of_available_programs) === 0;
  return /* @__PURE__ */ React10.createElement(
    Flex5,
    {
      padding: !isNewJourneyExperienceEnabled && {
        _: "oneAndHalf",
        phone: "twoAndHalf"
      },
      maxWidth: 1350,
      minWidth: "70%",
      marginX: "auto"
    },
    !isNewJourneyExperienceEnabled && /* @__PURE__ */ React10.createElement(PageHeaderBackground, null),
    /* @__PURE__ */ React10.createElement(Flex5, { flexDirection: { _: "column", tablet: "row" }, width: "100%" }, !isNewJourneyExperienceEnabled && /* @__PURE__ */ React10.createElement(
      BackButtonArrow2,
      {
        as: Link4,
        color: "onSurface.text.primary",
        fontSize: "heading3",
        marginInlineEnd: "one",
        marginY: "quarter",
        to: JOURNEY_ROUTES4.progressHome
      }
    ), /* @__PURE__ */ React10.createElement(Box7, { width: "100%" }, /* @__PURE__ */ React10.createElement(
      HeadingOne,
      {
        marginBottom: isNewJourneyExperienceEnabled ? "two" : "five",
        as: isNewJourneyExperienceEnabled ? "h2" : "h1"
      },
      formatMessage({ id: "PROGRAM_LIBRARY" })
    ), isProgramLimitReached && /* @__PURE__ */ React10.createElement(
      ProgramLimitReached,
      {
        setShowProgramLimitModel
      }
    ), /* @__PURE__ */ React10.createElement(
      HealthProgramCarousels,
      {
        isLoading: isHealthProgramSuggestedCarouselsLoading,
        carousels: healthProgramSuggestedCarouselsData == null ? void 0 : healthProgramSuggestedCarouselsData.carousels,
        carouselsCategory: "health campaign library"
      }
    ), ((_a = healthProgramCategoriesData == null ? void 0 : healthProgramCategoriesData.categories) == null ? void 0 : _a.length) > 0 && /* @__PURE__ */ React10.createElement(HealthProgramCategories, null), isChallengesEnabled && !isChallengeHealthProgramError && /* @__PURE__ */ React10.createElement(
      HealthProgramCarousels,
      {
        ready: isChallengeHealthProgramReady,
        carousels: challengeHealthProgramCarousels,
        carouselsCategory: "health campaign library",
        linkCta: isChallengesWellnessAndRewardsEnabled && formatMessage({ id: "VIEW_ALL" }),
        linkUrl: isChallengesWellnessAndRewardsEnabled && JOURNEY_ROUTES4.getAllChallengeType()
      }
    ), /* @__PURE__ */ React10.createElement(
      HealthProgramCarousels,
      {
        isLoading: isHealthProgramCuratedCarouselsLoading,
        carousels: healthProgramCuratedCarouselsData == null ? void 0 : healthProgramCuratedCarouselsData.carousels,
        carouselsCategory: "health campaign library"
      }
    ), /* @__PURE__ */ React10.createElement(HealthGoalPrograms, null))),
    showProgramLimitModel && /* @__PURE__ */ React10.createElement(
      ProgramLimitModal,
      {
        title: (_b = healthProgramsData == null ? void 0 : healthProgramsData.program_limit_modal) == null ? void 0 : _b.title,
        description: (_c = healthProgramsData == null ? void 0 : healthProgramsData.program_limit_modal) == null ? void 0 : _c.description,
        onClose: () => {
          setShowProgramLimitModel(false);
        }
      }
    )
  );
};

// src/pages/program-details/health-program-details.component.jsx
import React23, { useState as useState5, useMemo as useMemo4, useEffect as useEffect5 } from "react";
import {
  Flex as Flex10,
  Box as Box13,
  HeadingTwo as HeadingTwo3,
  HeadingFour,
  SubtitleTwo as SubtitleTwo3,
  BodyOne as BodyOne3,
  CoverImage as CoverImage5,
  genesisStyled as genesisStyled5,
  SubtleButton as SubtleButton3,
  Link as Link7
} from "@leagueplatform/genesis-commons";
import {
  LoadingIndicator,
  HighlightBanner,
  ErrorState as ErrorState2
} from "@leagueplatform/web-common-components";
import {
  splitAtNewlines,
  truncateWithEllipses,
  useDocumentTitle as useDocumentTitle2
} from "@leagueplatform/web-common";
import { AchievementCalloutBanner } from "@leagueplatform/health-journey-common";
import { useIntl as useIntl14 } from "@leagueplatform/locales";
import { useFeatureFlagQuery as useFeatureFlagQuery9 } from "@leagueplatform/user-profile-api";
import { ACHIEVEMENTS_ENABLED } from "@leagueplatform/rewards-achievements";

// src/constants/health-program-status.constants.js
var HEALTH_PROGRAM_STATUS = {
  ACTIVE: "active",
  AVAILABLE: "available",
  UNAVAILABLE: "unavailable"
};
var JOURNEY_MANAGER_ENABLED = "journey_manager";

// src/pages/program-details/health-program-details.component.jsx
import { handleStaticAsset as handleStaticAsset5 } from "@leagueplatform/asset-config";

// src/pages/program-details/hooks/use-health-programs-program-details.hook.js
import { useCallback, useMemo as useMemo3 } from "react";
import {
  useParamsLegacy as useParams2,
  useLocationLegacy as useLocation2
} from "@leagueplatform/routing";
import isEmpty from "lodash/isEmpty";
import { useIntl as useIntl6 } from "@leagueplatform/locales";
import {
  JOURNEY_ROUTES as JOURNEY_ROUTES7,
  useHelpCenterLinks
} from "@leagueplatform/health-journey-common";
import {
  getParameterByName,
  getContentfulImageUrl
} from "@leagueplatform/web-common";
import { getContentUrl } from "@leagueplatform/league-content-api";

// src/pages/program-details/hooks/use-get-health-program.hook.js
import { useQuery as useQuery6 } from "@tanstack/react-query";
import {
  getHealthGoalProgram,
  GET_HEALTH_GOAL_PROGRAM_MESSAGE_TYPE
} from "@leagueplatform/health-journey-api";
var useGetHealthProgram = (programId) => useQuery6(
  [GET_HEALTH_GOAL_PROGRAM_MESSAGE_TYPE, programId],
  () => getHealthGoalProgram(programId)
);

// src/pages/program-details/hooks/use-start-health-program.hook.js
import { useQueryClient, useMutation } from "@tanstack/react-query";
import {
  useNavigateLegacy as useNavigate,
  useLocationLegacy as useLocation
} from "@leagueplatform/routing";
import {
  GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE,
  GET_USER_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE,
  GET_ACTIVE_CAMPAIGN_LIMIT_INFO_MESSAGE_TYPE as GET_ACTIVE_CAMPAIGN_LIMIT_INFO_MESSAGE_TYPE2,
  startHealthGoalProgram
} from "@leagueplatform/health-journey-api";
import { toastActions, TOAST_STATUS } from "@leagueplatform/toast-messages";
import {
  JOURNEY_ROUTES as JOURNEY_ROUTES5,
  useApiDelayController
} from "@leagueplatform/health-journey-common";
var useStartHealthProgram = (programId, isUserDeviceConnectableProgram) => {
  var _a;
  const queryClient = useQueryClient();
  const apiDelayController = useApiDelayController();
  const navigate = useNavigate();
  const location = useLocation();
  const { activityId: redirectActivityId, activityType: redirectActivityType } = (_a = location == null ? void 0 : location.state) != null ? _a : {};
  return useMutation(
    (campaignMode) => startHealthGoalProgram(
      programId,
      isUserDeviceConnectableProgram,
      campaignMode
    ),
    {
      onMutate: () => {
        apiDelayController.init();
      },
      onSuccess: (data) => __async(void 0, null, function* () {
        yield apiDelayController.finish();
        const isMaxProgramLimitReached = data == null ? void 0 : data.content_for_users_state;
        if (!isMaxProgramLimitReached) {
          toastActions.add({
            type: TOAST_STATUS.SUCCESS,
            textId: "PROGRAM_ADDED",
            contentId: "THE_PROGRAM_WILL_APPEAR_IN_JOURNEY"
          });
          if (redirectActivityId) {
            navigate(
              JOURNEY_ROUTES5.getActivityDetails(
                redirectActivityId,
                redirectActivityType
              )
            );
          } else {
            navigate(JOURNEY_ROUTES5.journeyHome());
          }
        }
        return data;
      }),
      onError: () => __async(void 0, null, function* () {
        yield apiDelayController.finish();
        toastActions.add({
          type: TOAST_STATUS.ERROR,
          textId: "ERROR_STATE_TITLE",
          contentId: "PROGRAM_ADD_ERROR"
        });
      }),
      onSettled: () => {
        queryClient.invalidateQueries([
          GET_USER_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE
        ]);
        queryClient.invalidateQueries([
          GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE
        ]);
        queryClient.invalidateQueries([
          GET_ACTIVE_CAMPAIGN_LIMIT_INFO_MESSAGE_TYPE2
        ]);
      }
    }
  );
};

// src/pages/program-details/hooks/use-quit-health-program.hook.js
import {
  useNavigateLegacy as useNavigate2,
  useParamsLegacy as useParams
} from "@leagueplatform/routing";
import { useQueryClient as useQueryClient2, useMutation as useMutation2 } from "@tanstack/react-query";
import {
  GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE as GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE2,
  GET_USER_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE as GET_USER_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE2,
  GET_ACTIVE_CAMPAIGN_LIMIT_INFO_MESSAGE_TYPE as GET_ACTIVE_CAMPAIGN_LIMIT_INFO_MESSAGE_TYPE3,
  quitHealthGoalProgram
} from "@leagueplatform/health-journey-api";
import { toastActions as toastActions2, TOAST_STATUS as TOAST_STATUS2 } from "@leagueplatform/toast-messages";
import { JOURNEY_ROUTES as JOURNEY_ROUTES6 } from "@leagueplatform/health-journey-common";

// src/constants/health-program-modal.constants.js
var SHOW_PULSE_CHECK_MODAL = "showPulseCheckModal";

// src/pages/program-details/hooks/use-quit-health-program.hook.js
var useQuitHealthProgram = (userProgramId) => {
  var _a, _b;
  const { programId } = useParams();
  const queryClient = useQueryClient2();
  const navigate = useNavigate2();
  const { data: programData } = useGetHealthProgram(programId);
  const program = (programData == null ? void 0 : programData.program) || {};
  const { campaign_content_config: contentConfig } = program;
  const pulseCheckUrl = (_b = (_a = contentConfig == null ? void 0 : contentConfig.pulse_checks) == null ? void 0 : _a[0]) == null ? void 0 : _b.ctaUrl;
  return useMutation2(() => quitHealthGoalProgram(userProgramId), {
    onSuccess: () => {
      toastActions2.add({
        type: TOAST_STATUS2.SUCCESS,
        textId: "PROGRAM_REMOVED",
        contentId: "YOU_WILL_NO_LONGER_SEE_IN_JOURNEY"
      });
    },
    onError: () => {
      toastActions2.add({
        type: TOAST_STATUS2.ERROR,
        textId: "ERROR_STATE_TITLE",
        contentId: "PROGRAM_REMOVE_ERROR"
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries([
        GET_USER_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE2
      ]);
      queryClient.invalidateQueries([GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE2]);
      queryClient.invalidateQueries([
        GET_ACTIVE_CAMPAIGN_LIMIT_INFO_MESSAGE_TYPE3
      ]);
      if (pulseCheckUrl) {
        navigate(JOURNEY_ROUTES6.journeyHome(), {
          state: {
            programId,
            type: SHOW_PULSE_CHECK_MODAL
          }
        });
      } else {
        navigate(JOURNEY_ROUTES6.journeyHome());
      }
    }
  });
};

// src/pages/program-details/hooks/use-user-has-sufficient-wearable-permissions.hook.js
import * as React11 from "react";
import {
  findGrantedWearablePermissions,
  doesUserHaveSufficientWearablePermissions,
  useGetWearablesConsentForDataPoints
} from "@leagueplatform/health-journey-api";
var useUserHasSufficientWearablePermissions = (contentConfig) => {
  const requiredWearableHealthPermissions = contentConfig == null ? void 0 : contentConfig.dataFields;
  const { data: wearablesData = {}, isLoading } = useGetWearablesConsentForDataPoints(requiredWearableHealthPermissions);
  const { receiving_data_v2: devicesObj = {} } = wearablesData;
  const userHasSufficientWearablePermissions = React11.useMemo(() => {
    if (!requiredWearableHealthPermissions) {
      return null;
    }
    const grantedWearableHealthPermissions = findGrantedWearablePermissions(devicesObj);
    return doesUserHaveSufficientWearablePermissions(
      requiredWearableHealthPermissions,
      grantedWearableHealthPermissions
    );
  }, [devicesObj, requiredWearableHealthPermissions]);
  return { userHasSufficientWearablePermissions, isLoading };
};

// src/pages/program-details/hooks/use-health-programs-program-details.hook.js
var mapParamToPath = {
  home: JOURNEY_ROUTES7.memberHome,
  progress: JOURNEY_ROUTES7.progressHome
};
var getIsUserDeviceConnectableProgram = (contentConfig) => {
  if (!contentConfig)
    return null;
  return Array.isArray(contentConfig == null ? void 0 : contentConfig.dataFields) && contentConfig.dataFields.length > 0;
};
var getGoBackPath = (queryString) => {
  const route = !isEmpty(queryString) && getParameterByName("b", queryString);
  return Object.prototype.hasOwnProperty.call(mapParamToPath, route) ? mapParamToPath[route] : JOURNEY_ROUTES7.programsHome;
};
var getSyncableDevicesString = (contentConfig, $tmap, formatMessage) => {
  if (!getIsUserDeviceConnectableProgram(contentConfig))
    return null;
  const map = $tmap({
    distance: "INSIGHT_CARD_HEADER_DISTANCE",
    steps: "INSIGHT_CARD_HEADER_STEPS",
    active_duration: "INSIGHT_CARD_HEADER_ACTIVE_DURATION",
    mindful_duration: "INSIGHT_CARD_HEADER_MINDFUL_DURATION",
    floors_climbed: "INSIGHT_CARD_HEADER_FLOORS_CLIMBED",
    energy_burned: "INSIGHT_CARD_HEADER_ENERGY_BURNED"
  });
  return contentConfig == null ? void 0 : contentConfig.dataFields.map((field) => map(field)).join(` ${formatMessage({ id: "AND" })} `);
};
var getProgressPercentages = ({
  completed_activity_progress_percentage: completed,
  missed_activity_progress_percentage: missed
}) => ({ completed, missed });
var getActivityStatusCounts = ({
  total_activities_count: total = 0,
  activity_status_counts: counts = {}
}) => __spreadValues({ total }, counts);
var useHealthProgramsProgramDetails = () => {
  const { formatMessage, $tmap } = useIntl6();
  const { programId } = useParams2();
  const location = useLocation2();
  const {
    data: programData,
    isError,
    isLoading: isLoadingGetProgram,
    error
  } = useGetHealthProgram(programId);
  const program = (programData == null ? void 0 : programData.program) || {};
  const {
    campaign_content_config: contentConfig,
    user_program_id: userProgramId
  } = program;
  const isUserDeviceConnectableProgram = getIsUserDeviceConnectableProgram(contentConfig);
  const { mutate: requestLeaveHealthProgram } = useQuitHealthProgram(userProgramId);
  const { mutate: requestStartHealthProgram, data: startProgramData } = useStartHealthProgram(programId, isUserDeviceConnectableProgram);
  const {
    userHasSufficientWearablePermissions,
    isInitialLoading: isLoadingWearablePermissions
  } = useUserHasSufficientWearablePermissions(contentConfig);
  const constructContentForUsersState = useCallback(() => {
    var _a, _b, _c, _d, _e;
    const contentfulImageAssetUrl = (_d = (_c = (_b = (_a = startProgramData == null ? void 0 : startProgramData.content_for_users_state) == null ? void 0 : _a.contentful_image_asset) == null ? void 0 : _b.fields) == null ? void 0 : _c.file) == null ? void 0 : _d.url;
    const imageIdUrl = (_e = startProgramData == null ? void 0 : startProgramData.content_for_users_state) == null ? void 0 : _e.image_id;
    return __spreadProps(__spreadValues({}, startProgramData == null ? void 0 : startProgramData.content_for_users_state), {
      imageUrl: contentfulImageAssetUrl ? getContentfulImageUrl(contentfulImageAssetUrl) : getContentUrl(imageIdUrl)
    });
  }, [startProgramData]);
  const startProgramMaxEnrolmentModalContent = useMemo3(
    () => (startProgramData == null ? void 0 : startProgramData.content_for_users_state) ? constructContentForUsersState() : null,
    [constructContentForUsersState, startProgramData == null ? void 0 : startProgramData.content_for_users_state]
  );
  const { whatAreConnectedHealthProgramsLink } = useHelpCenterLinks();
  return {
    achievementImage: program == null ? void 0 : program.achievement_image_url,
    activityStatusCounts: getActivityStatusCounts(program),
    availablePoints: program == null ? void 0 : program.available_points,
    description: program == null ? void 0 : program.long_description,
    goals: program == null ? void 0 : program.goals,
    goBackPath: getGoBackPath(location == null ? void 0 : location.search),
    hasError: isError,
    image: program == null ? void 0 : program.image_url,
    isUserDeviceConnectableProgram,
    userHasSufficientWearablePermissions,
    programDataPoints: contentConfig == null ? void 0 : contentConfig.dataFields,
    name: program == null ? void 0 : program.name,
    programId,
    progressPercentages: getProgressPercentages(program),
    ready: !isLoadingGetProgram && !isLoadingWearablePermissions,
    requestLeaveHealthProgram,
    requestStartHealthProgram,
    startProgramMaxEnrolmentModalContent,
    status: program == null ? void 0 : program.status,
    syncableDevicesString: getSyncableDevicesString(
      contentConfig,
      $tmap,
      formatMessage
    ),
    whatAreConnectedHealthProgramsLink,
    error
  };
};

// src/pages/main/components/health-program-category/health-programs-category.component.jsx
import React12 from "react";
import { Flex as Flex6 } from "@leagueplatform/genesis-commons";
import PropTypes5 from "prop-types";
var HealthProgramCategory = ({ children }) => /* @__PURE__ */ React12.createElement(
  Flex6,
  {
    paddingY: "oneAndHalf",
    paddingX: "one",
    alignItems: "center",
    borderRadius: "large",
    borderStyle: "solid",
    borderWidth: "thin",
    borderColor: "onSurface.border.subdued",
    width: "100%",
    height: "100%"
  },
  children
);
HealthProgramCategory.propTypes = {
  children: PropTypes5.node
};
HealthProgramCategory.defaultProps = {
  children: ""
};

// src/pages/program-details/parts/health-programs-program-details-sidebar.component.jsx
import React21, { useState as useState4, useEffect as useEffect4, useCallback as useCallback2 } from "react";
import PropTypes9 from "prop-types";
import { useIntl as useIntl13 } from "@leagueplatform/locales";
import {
  Flex as Flex9,
  SubtitleOne as SubtitleOne3,
  SubtitleTwo as SubtitleTwo2,
  CoverImage as CoverImage4
} from "@leagueplatform/genesis-commons";
import { CompoundProgressBar } from "@leagueplatform/ui-kit";
import { arrayToTag as arrayToTag3 } from "@leagueplatform/web-common";
import {
  useApiDelayOverlay,
  ViewTransitionController,
  ApiDelayOverlay
} from "@leagueplatform/health-journey-common";

// src/utils/health-programs-progress-bar-factory.js
var programProgressBarSegmentFactory = ({ completed, missed }) => [
  {
    key: "complete",
    percent: completed,
    color: "success.icon"
  },
  {
    key: "missed",
    percent: missed,
    color: "onSurface.text.subdued"
  }
];

// src/pages/program-details/parts/health-programs-program-details-sidebar.component.jsx
import { handleStaticAsset as handleStaticAsset4 } from "@leagueplatform/asset-config";
import {
  Box as Box12,
  Card as Card2,
  queryHelpers,
  StackLayout as StackLayout3,
  useMediaQuery
} from "@leagueplatform/genesis-core";

// src/pages/program-details/hooks/use-program-details-analytics.js
import {
  trackAnalyticsEvent as trackAnalyticsEvent3,
  PRODUCT_AREA as PRODUCT_AREA3,
  EVENT_NAME as EVENT_NAME3
} from "@leagueplatform/analytics";
import { SCREEN_NAMES as SCREEN_NAMES2 } from "@leagueplatform/health-journey-common";
var useProgramDetailsAnalytics = (programName, programId, status) => {
  const { data: campaignLimitInfo = {} } = useActiveCampaignInfo();
  const {
    number_of_enrolled_programs: activeCampaigns,
    max_programs_limit: campaignLimit
  } = campaignLimitInfo;
  const baseAnalytics = {
    product_area: PRODUCT_AREA3.JOURNEY,
    health_campaign_name: programName,
    health_campaign_id: programId,
    screen_name: SCREEN_NAMES2.HEALTH_CAMPAIGN_DETAIL
  };
  const numOfCampaignData = {
    num_health_campaign_active: activeCampaigns,
    num_health_campaign_limit: campaignLimit
  };
  return {
    viewProgramDetailsRemoveModal: () => trackAnalyticsEvent3(EVENT_NAME3.SCREEN_LOADED, __spreadProps(__spreadValues({}, baseAnalytics), {
      screen_name: SCREEN_NAMES2.HEALTH_CAMPAIGN_REMOVAL
    })),
    viewProgramDetailsPage: () => trackAnalyticsEvent3(EVENT_NAME3.SCREEN_LOADED, __spreadProps(__spreadValues({}, baseAnalytics), {
      is_active_health_campaign: status === HEALTH_PROGRAM_STATUS.ACTIVE
    })),
    detailsBackButton: () => trackAnalyticsEvent3(EVENT_NAME3.BUTTON_CLICKED, __spreadProps(__spreadValues({}, baseAnalytics), {
      detail: "close",
      is_active_health_campaign: status === HEALTH_PROGRAM_STATUS.ACTIVE
    })),
    leaveProgram: () => trackAnalyticsEvent3(EVENT_NAME3.BUTTON_CLICKED, __spreadProps(__spreadValues(__spreadValues({}, baseAnalytics), numOfCampaignData), {
      detail: "remove health campaign"
    })),
    leaveConfirm: () => trackAnalyticsEvent3(EVENT_NAME3.BUTTON_CLICKED, __spreadProps(__spreadValues({}, baseAnalytics), {
      screen_name: SCREEN_NAMES2.HEALTH_CAMPAIGN_REMOVAL,
      detail: "confirm health campaign removal"
    })),
    leaveCancel: () => trackAnalyticsEvent3(EVENT_NAME3.BUTTON_CLICKED, __spreadProps(__spreadValues({}, baseAnalytics), {
      screen_name: SCREEN_NAMES2.HEALTH_CAMPAIGN_REMOVAL,
      detail: "cancel health campaign removal"
    })),
    addProgram: () => trackAnalyticsEvent3(EVENT_NAME3.BUTTON_CLICKED, __spreadProps(__spreadValues(__spreadValues({}, baseAnalytics), numOfCampaignData), {
      detail: "enroll in health campaign"
    }))
  };
};

// src/pages/program-details/parts/health-programs-program-details-remove-program-modal.component.tsx
import React13, { useEffect as useEffect3 } from "react";
import { useIntl as useIntl7 } from "@leagueplatform/locales";
import {
  Box as Box8,
  Button,
  HeadingText as HeadingText2,
  Image,
  Modal,
  StackLayout as StackLayout2,
  UtilityText
} from "@leagueplatform/genesis-core";
import { useStaticAsset } from "@leagueplatform/asset-config";
import { HEALTH_JOURNEY_COMMON_ASSET_KEYS } from "@leagueplatform/health-journey-common";
var modalTitleId = "remove-program-modal-title";
var RemoveProgramModal = ({
  onClose,
  requestLeaveHealthProgram,
  onProgramRemove,
  programName,
  programId
}) => {
  const { formatMessage } = useIntl7();
  const programDetailsAnalytics = useProgramDetailsAnalytics(
    programName,
    programId
  );
  useEffect3(() => {
    programDetailsAnalytics.viewProgramDetailsRemoveModal();
  }, []);
  const removeActivityImage = useStaticAsset(
    HEALTH_JOURNEY_COMMON_ASSET_KEYS.REMOVE_PROGRAM_IMAGE
  );
  return /* @__PURE__ */ React13.createElement(
    Modal.Root,
    {
      defaultOpen: true,
      onOpenChange: (open) => {
        if (!open && onClose) {
          onClose();
        }
      },
      "aria-label": modalTitleId
    },
    /* @__PURE__ */ React13.createElement(Modal.Content, { layout: "standard" }, /* @__PURE__ */ React13.createElement(Modal.Title, { hidden: true }, formatMessage({ id: "REMOVE_PROGRAM" })), /* @__PURE__ */ React13.createElement(
      StackLayout2,
      {
        css: { padding: "$two" },
        spacing: "$one",
        orientation: "vertical",
        horizontalAlignment: "center"
      },
      /* @__PURE__ */ React13.createElement(Image, { src: removeActivityImage }),
      /* @__PURE__ */ React13.createElement(
        Box8,
        {
          css: {
            width: "30ch",
            textAlign: "center",
            paddingBottom: "$one"
          }
        },
        /* @__PURE__ */ React13.createElement(HeadingText2, { size: "xl", level: "2" }, formatMessage({ id: "REMOVE_PROGRAM" }))
      ),
      /* @__PURE__ */ React13.createElement(
        Box8,
        {
          css: {
            width: "30ch",
            textAlign: "center",
            paddingBottom: "$one"
          }
        },
        /* @__PURE__ */ React13.createElement(UtilityText, null, formatMessage({ id: "ARE_YOU_SURE_REMOVE_PROGRAM" }))
      ),
      /* @__PURE__ */ React13.createElement(
        Button,
        {
          priority: "primary",
          size: "large",
          textAlign: "start",
          type: "button",
          width: "fillContainer",
          destructive: true,
          onClick: () => {
            requestLeaveHealthProgram();
            onProgramRemove();
          }
        },
        formatMessage({ id: "REMOVE_PROGRAM_BUTTON" })
      ),
      /* @__PURE__ */ React13.createElement(
        Button,
        {
          priority: "secondary",
          size: "large",
          textAlign: "start",
          type: "button",
          width: "fillContainer",
          onClick: () => {
            onClose();
          }
        },
        formatMessage({ id: "CANCEL" })
      )
    ))
  );
};

// src/pages/program-details/parts/health-programs-program-details-max-enrolment-modal.component.jsx
import React15 from "react";
import PropTypes7 from "prop-types";
import {
  CoverImage as CoverImage3,
  Box as Box9,
  HeadingThree,
  BodyTwo as BodyTwo2,
  PrimaryButton
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl9 } from "@leagueplatform/locales";

// src/pages/program-details/parts/health-programs-program-details-modal.component.jsx
import React14 from "react";
import PropTypes6 from "prop-types";
import {
  QuietButton,
  genesisStyled as genesisStyled3,
  css,
  VisuallyHidden
} from "@leagueplatform/genesis-commons";
import { Modal as Modal2, Icon as Icon2, ICONS } from "@leagueplatform/ui-kit";
import { useIntl as useIntl8 } from "@leagueplatform/locales";
var StyledModalContainer = genesisStyled3(Modal2.Container)(
  css({
    backgroundColor: "surface.background.primary",
    position: "relative",
    maxWidth: 458,
    borderRadius: "medium",
    overflow: "scroll"
  })
);
var StyledModalBody = genesisStyled3(Modal2.Body)(
  ({ bodyStyleOverrides }) => css(__spreadValues({
    padding: "twoAndHalf"
  }, bodyStyleOverrides))
);
var CloseButton = genesisStyled3(QuietButton)(
  css({
    position: "absolute",
    insetInlineEnd: 0,
    padding: "half",
    margin: "one"
  })
);
var HealthProgramsProgramDetailsModal = ({
  onClose,
  children,
  "aria-labelledby": ariaLabelledBy,
  bodyStyleOverrides
}) => {
  const { formatMessage } = useIntl8();
  return /* @__PURE__ */ React14.createElement(Modal2.Wrapper, { onClose }, /* @__PURE__ */ React14.createElement(StyledModalContainer, { "aria-labelledby": ariaLabelledBy }, /* @__PURE__ */ React14.createElement(CloseButton, { onClick: onClose }, /* @__PURE__ */ React14.createElement(VisuallyHidden, null, formatMessage({ id: "CLOSE" })), /* @__PURE__ */ React14.createElement(Icon2, { icon: ICONS.CLOSE, size: 16, "aria-hidden": "true" })), /* @__PURE__ */ React14.createElement(StyledModalBody, { bodyStyleOverrides }, children)));
};
HealthProgramsProgramDetailsModal.propTypes = {
  onClose: PropTypes6.func.isRequired,
  children: PropTypes6.node.isRequired,
  "aria-labelledby": PropTypes6.string.isRequired,
  bodyStyleOverrides: PropTypes6.shape({
    padding: PropTypes6.string
  })
};
HealthProgramsProgramDetailsModal.defaultProps = {
  bodyStyleOverrides: {}
};

// src/pages/program-details/parts/health-programs-program-details-max-enrolment-modal.component.jsx
var modalTitleId2 = "max-enrolment-modal-title";
var MaxEnrolmentModal = ({ onClose, image, title, description }) => {
  const { formatMessage } = useIntl9();
  return /* @__PURE__ */ React15.createElement(
    HealthProgramsProgramDetailsModal,
    {
      onClose,
      "aria-labelledby": modalTitleId2
    },
    /* @__PURE__ */ React15.createElement(Box9, { textAlign: "center" }, /* @__PURE__ */ React15.createElement(CoverImage3, { src: image, size: 140, marginY: "oneAndHalf" }), /* @__PURE__ */ React15.createElement(HeadingThree, { marginBottom: "half" }, title), /* @__PURE__ */ React15.createElement(BodyTwo2, { marginBottom: "two" }, description), /* @__PURE__ */ React15.createElement(PrimaryButton, { width: "123px", onClick: () => onClose() }, formatMessage({ id: "OK" })))
  );
};
MaxEnrolmentModal.propTypes = {
  onClose: PropTypes7.func.isRequired,
  image: PropTypes7.string,
  title: PropTypes7.string,
  description: PropTypes7.string
};
MaxEnrolmentModal.defaultProps = {
  image: "",
  title: "",
  description: ""
};

// src/pages/program-details/parts/health-programs-program-details-verifiable-activity-modal.component.tsx
import React19, { useState as useState3 } from "react";

// src/pages/program-details/parts/unavailable-device-connect-modal.component.tsx
import React17 from "react";
import { useConfigProperty } from "@leagueplatform/core";
import { useIntl as useIntl10 } from "@leagueplatform/locales";
import {
  Flex as Flex8,
  genesisStyled as genesisStyled4,
  Link as Link5,
  Overline as Overline2,
  SubtleLink
} from "@leagueplatform/genesis-commons";
import { useHelpCenterLinks as useHelpCenterLinks2 } from "@leagueplatform/health-journey-common";
import {
  GoogleAppIcon,
  AppleAppIcon
} from "@leagueplatform/web-common-components";

// src/hooks/use-is-dashboard-enabled.tsx
import { useFeatureFlagQuery as useFeatureFlagQuery6 } from "@leagueplatform/user-profile-api";
var useIsDashboardEnabled = () => {
  const ENABLE_DASHBOARD_WEB = "enable_dashboard_web";
  const ENABLE_DASHBOARD_BE = "enable_dashboard";
  const { isLoading: isWebLoading, data: isDashboardWebEnabled } = useFeatureFlagQuery6(ENABLE_DASHBOARD_WEB);
  const { isLoading: isBeLoading, data: isDashboardBeEnabled } = useFeatureFlagQuery6(ENABLE_DASHBOARD_BE);
  const isDashboardEnabled = isDashboardWebEnabled && isDashboardBeEnabled;
  const isLoading = isWebLoading || isBeLoading;
  return {
    isLoading,
    isDashboardEnabled
  };
};

// src/pages/program-details/parts/unavailable-device-connect-modal.component.tsx
import { handleStaticAsset as handleStaticAsset2 } from "@leagueplatform/asset-config";

// src/pages/program-details/parts/connect-devices-modal.component.tsx
import React16 from "react";
import {
  Flex as Flex7,
  BodyOne as BodyOne2,
  Box as Box10,
  Image as Image2,
  HeadingThree as HeadingThree2
} from "@leagueplatform/genesis-commons";
var IMAGE_SIZE = "120px";
var ConnectDevicesModal = ({
  img,
  altTxt,
  heading,
  body,
  children,
  onClose
}) => /* @__PURE__ */ React16.createElement(
  HealthProgramsProgramDetailsModal,
  {
    onClose,
    "aria-labelledby": "modal-label"
  },
  /* @__PURE__ */ React16.createElement(Box10, { textAlign: "center" }, /* @__PURE__ */ React16.createElement(Box10, { margin: "two" }, /* @__PURE__ */ React16.createElement(Image2, { width: IMAGE_SIZE, src: img, alt: altTxt })), /* @__PURE__ */ React16.createElement(
    HeadingThree2,
    {
      as: "h2",
      id: "modal-label",
      marginTop: "half",
      marginBottom: "threeQuarters"
    },
    heading
  ), /* @__PURE__ */ React16.createElement(BodyOne2, { color: "onSurface.text.subdued", marginBottom: "two" }, body), /* @__PURE__ */ React16.createElement(Flex7, { flexDirection: "column" }, children))
);

// src/pages/program-details/parts/unavailable-device-connect-modal.component.tsx
var STORE_IMG_HEIGHT = "50px";
var AppIconContainer = genesisStyled4(Flex8)`
  gap: ${({ theme }) => `${theme == null ? void 0 : theme.space.half}px`};
`;
var UnavailableDeviceConnectModal = ({
  onClose
}) => {
  const { formatMessage } = useIntl10();
  const { whatDevicesCanConnectLink, gettingStartedWithLeagueLink } = useHelpCenterLinks2();
  const { isDashboardEnabled } = useIsDashboardEnabled();
  const { data: mobileAppUrls } = useConfigProperty(
    "config_core-web.mobileAppUrls"
  );
  const connectionUnavailable = handleStaticAsset2(
    "DEVICE_CONNECTION_ERROR_ICON" /* DEVICE_CONNECTION_ERROR_ICON */
  );
  if (!isDashboardEnabled) {
    return /* @__PURE__ */ React17.createElement(
      ConnectDevicesModal,
      {
        img: connectionUnavailable,
        altTxt: formatMessage({ id: "CONNECTING_UNAVAILABLE" }),
        heading: formatMessage({ id: "CONNECTING_UNAVAILABLE" }),
        body: formatMessage({ id: "CONNECTING_UNAVAILABLE_DETAILS" }),
        onClose
      },
      /* @__PURE__ */ React17.createElement(
        Link5,
        {
          href: gettingStartedWithLeagueLink,
          marginBottom: "half",
          target: "_blank"
        },
        formatMessage({ id: "DONT_HAVE_THE_APP" })
      ),
      /* @__PURE__ */ React17.createElement(Link5, { href: whatDevicesCanConnectLink, target: "_blank" }, formatMessage({ id: "WHAT_DEVICES_CAN_CONNECT" }))
    );
  }
  return /* @__PURE__ */ React17.createElement(
    ConnectDevicesModal,
    {
      img: connectionUnavailable,
      altTxt: formatMessage({ id: "CONNECTING_UNAVAILABLE" }),
      heading: formatMessage({ id: "CONNECTING_UNAVAILABLE" }),
      body: /* @__PURE__ */ React17.createElement(React17.Fragment, null, formatMessage({ id: "CONNECTING_UNAVAILABLE_DETAILS_WITH_LINK" }), " ", /* @__PURE__ */ React17.createElement(
        SubtleLink,
        {
          href: whatDevicesCanConnectLink,
          target: "_blank",
          color: "interactive.action.primary"
        },
        formatMessage({ id: "APPS_AND_DEVICES_CURRENTLY_SUPPORTED" })
      )),
      onClose
    },
    /* @__PURE__ */ React17.createElement(Overline2, { as: "p" }, formatMessage({ id: "DONT_HAVE_THE_APP" })),
    /* @__PURE__ */ React17.createElement(AppIconContainer, { flexWrap: "wrap", justifyContent: "center", marginTop: "one" }, /* @__PURE__ */ React17.createElement(
      AppleAppIcon,
      {
        imageSize: STORE_IMG_HEIGHT,
        href: mobileAppUrls == null ? void 0 : mobileAppUrls.appStoreUrl
      }
    ), /* @__PURE__ */ React17.createElement(
      GoogleAppIcon,
      {
        imageSize: STORE_IMG_HEIGHT,
        href: mobileAppUrls == null ? void 0 : mobileAppUrls.playStoreUrl
      }
    ))
  );
};

// src/pages/program-details/parts/device-tracking-modal.component.tsx
import React18 from "react";
import { useIntl as useIntl11 } from "@leagueplatform/locales";
import { USER_CONNECTED_DEVICE_CAMPAIGN_MODES } from "@leagueplatform/health-journey-api";
import { QuietButton as QuietButton2, PrimaryButton as PrimaryButton2 } from "@leagueplatform/genesis-commons";
import { useFeatureFlagQuery as useFeatureFlagQuery7 } from "@leagueplatform/user-profile-api";
import { VERIFIABLE_AUTOMATIC_ONLY } from "@leagueplatform/health-journey-common";
import { handleStaticAsset as handleStaticAsset3 } from "@leagueplatform/asset-config";
var DeviceTrackingModal = ({
  onClose,
  userHasSufficientWearablePermissions,
  programDataPoints,
  programAddHandler,
  setDisplayUnavailableOnWebModal
}) => {
  const { data: manualProgramTrackingDisabled } = useFeatureFlagQuery7(
    VERIFIABLE_AUTOMATIC_ONLY
  );
  const { formatMessage, $tmap, formatList } = useIntl11();
  const connectedDeviceImage = handleStaticAsset3(
    "CONNECT_DEVICES" /* CONNECT_DEVICES */
  );
  const getDataPointMessage = $tmap({
    distance: "INSIGHT_CARD_HEADER_DISTANCE",
    steps: "INSIGHT_CARD_HEADER_STEPS",
    active_duration: "INSIGHT_CARD_HEADER_ACTIVE_DURATION",
    mindful_duration: "INSIGHT_CARD_HEADER_MINDFUL_DURATION",
    floors_climbed: "INSIGHT_CARD_HEADER_FLOORS_CLIMBED",
    energy_burned: "INSIGHT_CARD_HEADER_ENERGY_BURNED"
  });
  return /* @__PURE__ */ React18.createElement(
    ConnectDevicesModal,
    {
      img: connectedDeviceImage,
      altTxt: formatMessage({ id: "CONNECTED_DEVICES_IMAGE_ALT" }),
      heading: userHasSufficientWearablePermissions ? formatMessage({
        id: "DEVICES_CONNECTED_TITLE"
      }) : formatMessage({
        id: "TRACK_AUTOMATICALLY"
      }),
      body: userHasSufficientWearablePermissions ? formatMessage(
        {
          id: "DEVICES_CONNECTED_DESCRIPTION"
        },
        {
          dataPoint: formatList(
            programDataPoints.map(
              (dataPoint) => getDataPointMessage(dataPoint)
            )
          )
        }
      ) : formatMessage({
        id: "CONNECT_TO_TRACK"
      }),
      onClose
    },
    userHasSufficientWearablePermissions ? /* @__PURE__ */ React18.createElement(
      PrimaryButton2,
      {
        onClick: () => programAddHandler(USER_CONNECTED_DEVICE_CAMPAIGN_MODES.AUTOMATIC)
      },
      formatMessage({ id: "TRACK_CHALLENGE_AUTOMATICALLY" })
    ) : /* @__PURE__ */ React18.createElement(PrimaryButton2, { onClick: () => setDisplayUnavailableOnWebModal(true) }, formatMessage({ id: "CONNECT_APPS_DEVICES" })),
    !manualProgramTrackingDisabled && /* @__PURE__ */ React18.createElement(
      QuietButton2,
      {
        onClick: () => programAddHandler(USER_CONNECTED_DEVICE_CAMPAIGN_MODES.MANUAL),
        marginTop: "half"
      },
      formatMessage({ id: "DONT_CONNECT_APPS_DEVICES" })
    )
  );
};

// src/pages/program-details/parts/health-programs-program-details-verifiable-activity-modal.component.tsx
var VerifiableProgramModal = ({
  onClose,
  programAddHandler,
  userHasSufficientWearablePermissions,
  programDataPoints
}) => {
  const [displayUnavailableOnWebModal, setDisplayUnavailableOnWebModal] = useState3(false);
  if (displayUnavailableOnWebModal) {
    return /* @__PURE__ */ React19.createElement(UnavailableDeviceConnectModal, { onClose });
  }
  return /* @__PURE__ */ React19.createElement(
    DeviceTrackingModal,
    {
      onClose,
      userHasSufficientWearablePermissions,
      programDataPoints,
      programAddHandler,
      setDisplayUnavailableOnWebModal
    }
  );
};

// src/pages/program-details/parts/program-details-sidebar-cta-action.component.jsx
import * as React20 from "react";
import PropTypes8 from "prop-types";
import {
  SubtleButton as SubtleButton2,
  PrimaryButton as PrimaryButton3,
  SubtitleTwo,
  Box as Box11,
  Caption
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl12 } from "@leagueplatform/locales";
var ProgramDetailsSidebarCtaAction = ({
  isLoading,
  programStatus,
  onSelectAction
}) => {
  const { formatMessage } = useIntl12();
  const { ACTIVE: ACTIVE2, AVAILABLE: AVAILABLE2, UNAVAILABLE } = HEALTH_PROGRAM_STATUS;
  switch (programStatus) {
    case ACTIVE2:
      return /* @__PURE__ */ React20.createElement(
        SubtleButton2,
        {
          color: "onSurface.text.subdued",
          onClick: onSelectAction,
          isLoading,
          "data-testid": "program-details-remove-from-journey",
          borderWidth: "thin",
          width: "100%"
        },
        formatMessage({ id: "REMOVE_FROM_JOURNEY" })
      );
    case AVAILABLE2:
      return /* @__PURE__ */ React20.createElement(
        PrimaryButton3,
        {
          height: "three",
          onClick: onSelectAction,
          isLoading,
          "data-testid": "program-details-add-to-journey",
          width: "100%"
        },
        formatMessage({ id: "ADD_TO_JOURNEY" })
      );
    case UNAVAILABLE:
      return /* @__PURE__ */ React20.createElement(
        Box11,
        {
          backgroundColor: "surface.background.secondary",
          padding: "one",
          textAlign: "center",
          "data-testid": "program-details-program-limit"
        },
        /* @__PURE__ */ React20.createElement(SubtitleTwo, { marginBottom: "half" }, formatMessage({ id: "YOUVE_REACHED_PROGRAM_LIMIT" })),
        /* @__PURE__ */ React20.createElement(Caption, null, formatMessage({ id: "COMPLETE_ONE_OF_ACTIVE_PROGRAMS" }))
      );
    default:
      return null;
  }
};
ProgramDetailsSidebarCtaAction.propTypes = {
  isLoading: PropTypes8.bool,
  onSelectAction: PropTypes8.func,
  programStatus: PropTypes8.string.isRequired
};
ProgramDetailsSidebarCtaAction.defaultProps = {
  isLoading: false,
  onSelectAction: () => {
  }
};

// src/pages/program-details/types/program-details-modal.types.ts
var PROGRAM_DETAIL_MODALS = /* @__PURE__ */ ((PROGRAM_DETAIL_MODALS2) => {
  PROGRAM_DETAIL_MODALS2["DELAY_ACTIVE"] = "delay_active";
  PROGRAM_DETAIL_MODALS2["DEVICE_CONNECTED_PROGRAM"] = "verifiable_program";
  PROGRAM_DETAIL_MODALS2["MAX_ENROLLMENT"] = "max_enrollment";
  PROGRAM_DETAIL_MODALS2["REMOVE_PROGRAM"] = "remove_program";
  PROGRAM_DETAIL_MODALS2["NONE"] = "";
  return PROGRAM_DETAIL_MODALS2;
})(PROGRAM_DETAIL_MODALS || {});

// src/pages/program-details/parts/health-programs-program-details-sidebar.component.jsx
var {
  DELAY_ACTIVE,
  DEVICE_CONNECTED_PROGRAM,
  MAX_ENROLLMENT,
  REMOVE_PROGRAM,
  NONE
} = PROGRAM_DETAIL_MODALS;
var { ACTIVE, AVAILABLE } = HEALTH_PROGRAM_STATUS;
var ProgramDetailsSidebar = ({
  status,
  progressPercentages,
  availablePoints,
  requestLeaveHealthProgram,
  requestStartHealthProgram,
  startProgramMaxEnrolmentModalContent,
  programName,
  programId,
  isUserDeviceConnectableProgram,
  userHasSufficientWearablePermissions,
  programDataPoints,
  activityStatusCounts,
  hasError,
  ready
}) => {
  const { formatMessage, formatNumber } = useIntl13();
  const programDetailsAnalytics = useProgramDetailsAnalytics(
    programName,
    programId,
    status
  );
  const { delayOverlayActive } = useApiDelayOverlay();
  const [activeModal, setActiveModal] = useState4(NONE);
  const [isActionAwaitingResponse, setIsActionAwaitingResponse] = useState4(false);
  const onProgramModalClose = () => {
    programDetailsAnalytics.leaveCancel();
    setActiveModal(NONE);
  };
  const onProgramRemove = () => {
    programDetailsAnalytics.leaveConfirm();
    setActiveModal(NONE);
  };
  const userContent = startProgramMaxEnrolmentModalContent;
  const isContentReady = Boolean(userContent);
  useEffect4(() => {
    if (isContentReady) {
      setActiveModal(MAX_ENROLLMENT);
    }
  }, [isContentReady]);
  const isProgramActive = status === ACTIVE;
  const isAvailablePointsGreaterThanZero = availablePoints > 0;
  const { total, completed, removed, expired } = activityStatusCounts;
  const missed = removed + expired;
  const progressSegments = programProgressBarSegmentFactory(progressPercentages);
  const progressCaption = arrayToTag3([
    formatMessage({ id: "X_OF_Y_COMPLETE" }, { completed, total }),
    missed ? formatMessage({ id: "X_MISSED" }, { missed }) : null
  ]);
  const progressCaptionId = `progress-caption-${programId}`;
  const programAddHandler = (campaignMode) => {
    requestStartHealthProgram(campaignMode, {
      onSettled() {
        setIsActionAwaitingResponse(false);
      }
    });
    programDetailsAnalytics.addProgram();
  };
  const onDismissModal = (callback = () => {
  }) => {
    setIsActionAwaitingResponse(false);
    callback();
  };
  const triggerModalOnAction = () => {
    let isModalActive = false;
    if (status === ACTIVE) {
      setActiveModal(REMOVE_PROGRAM);
      isModalActive = true;
    } else if (status === AVAILABLE && isUserDeviceConnectableProgram) {
      setActiveModal(DEVICE_CONNECTED_PROGRAM);
      isModalActive = true;
    } else {
      setActiveModal(NONE);
    }
    return isModalActive;
  };
  const triggerModalOnApiResponse = useCallback2(() => {
    if (status === AVAILABLE) {
      if (delayOverlayActive) {
        setActiveModal(DELAY_ACTIVE);
      } else if (isContentReady) {
        setActiveModal(MAX_ENROLLMENT);
      } else {
        setActiveModal(NONE);
      }
    }
  }, [delayOverlayActive, isContentReady, status]);
  const onSelectAction = () => {
    setIsActionAwaitingResponse(true);
    const isModalActive = triggerModalOnAction();
    if (status === ACTIVE) {
      programDetailsAnalytics.leaveProgram();
    }
    if (status === AVAILABLE && !isModalActive) {
      programAddHandler();
    }
  };
  useEffect4(() => {
    if (ready && hasError) {
      setIsActionAwaitingResponse(false);
    }
    return () => setIsActionAwaitingResponse(false);
  }, [ready, hasError]);
  useEffect4(() => {
    triggerModalOnApiResponse();
  }, [triggerModalOnApiResponse]);
  const programDetailsModals = {
    [DELAY_ACTIVE]: {
      view: ApiDelayOverlay,
      props: {
        onClose: () => setActiveModal(NONE)
      }
    },
    [DEVICE_CONNECTED_PROGRAM]: {
      view: VerifiableProgramModal,
      props: {
        onClose: () => onDismissModal(() => setActiveModal(NONE)),
        programAddHandler: (campaignMode) => {
          programAddHandler(campaignMode);
          setActiveModal(NONE);
        },
        userHasSufficientWearablePermissions,
        programDataPoints
      }
    },
    [MAX_ENROLLMENT]: {
      view: MaxEnrolmentModal,
      props: {
        onClose: () => onDismissModal(() => setActiveModal(NONE)),
        image: userContent == null ? void 0 : userContent.imageUrl,
        title: userContent == null ? void 0 : userContent.title,
        description: userContent == null ? void 0 : userContent.description
      }
    },
    [REMOVE_PROGRAM]: {
      view: RemoveProgramModal,
      props: {
        requestLeaveHealthProgram,
        programName,
        programId,
        onProgramRemove: () => onDismissModal(onProgramRemove),
        onClose: () => onDismissModal(onProgramModalClose)
      }
    }
  };
  const clock2 = handleStaticAsset4("CLOCK" /* CLOCK */);
  const starRibbon2 = handleStaticAsset4("STAR_RIBBON" /* STAR_RIBBON */);
  const isMobile = useMediaQuery(queryHelpers.down("laptop"));
  return /* @__PURE__ */ React21.createElement(React21.Suspense, { fallback: null }, /* @__PURE__ */ React21.createElement(StackLayout3, { spacing: "$one" }, /* @__PURE__ */ React21.createElement(
    Card2.Elevated,
    {
      css: {
        width: "100%",
        padding: "$one",
        backgroundColor: "$surfaceBackgroundPrimary"
      }
    },
    isProgramActive ? /* @__PURE__ */ React21.createElement(StackLayout3, null, /* @__PURE__ */ React21.createElement(SubtitleOne3, { as: "h2", marginBottom: "oneAndHalf" }, formatMessage({ id: "PROGRESS" })), /* @__PURE__ */ React21.createElement(
      CompoundProgressBar,
      {
        "aria-describedby": progressCaptionId,
        segments: progressSegments,
        marginBottom: "half"
      }
    ), /* @__PURE__ */ React21.createElement(SubtitleTwo2, { id: progressCaptionId, as: "h3" }, progressCaption)) : /* @__PURE__ */ React21.createElement(StackLayout3, null, /* @__PURE__ */ React21.createElement(SubtitleOne3, { as: "h3", marginBottom: "oneAndHalf" }, formatMessage({ id: "PROGRAM_DETAILS" })), /* @__PURE__ */ React21.createElement(
      Flex9,
      {
        flexDirection: { _: "row", phone: "column" },
        justifyContent: !isAvailablePointsGreaterThanZero && "center"
      },
      /* @__PURE__ */ React21.createElement(
        Flex9,
        {
          marginInlineEnd: { _: "one", phone: "initial" },
          marginBottom: isAvailablePointsGreaterThanZero && {
            _: "initial",
            phone: "oneAndHalf"
          },
          alignItems: "center"
        },
        /* @__PURE__ */ React21.createElement(
          CoverImage4,
          {
            src: clock2,
            alt: "",
            marginInlineEnd: "threeQuarters",
            width: 22,
            height: 21
          }
        ),
        /* @__PURE__ */ React21.createElement(SubtitleTwo2, { as: "h4" }, `${total} ${formatMessage(
          {
            id: "ACTIVITIES_PLURALIZATION"
          },
          { count: total }
        ).toLowerCase()}`)
      ),
      isAvailablePointsGreaterThanZero && /* @__PURE__ */ React21.createElement(Flex9, { alignItems: "center" }, /* @__PURE__ */ React21.createElement(
        CoverImage4,
        {
          src: starRibbon2,
          alt: "",
          marginInlineEnd: "threeQuarters",
          size: 21
        }
      ), /* @__PURE__ */ React21.createElement(SubtitleTwo2, { as: "h4" }, formatMessage(
        { id: "EARN_UP_TO_X_POINTS" },
        {
          points: formatNumber(availablePoints, {
            style: "decimal"
          })
        }
      )))
    ))
  ), /* @__PURE__ */ React21.createElement(Box12, { css: { width: "100%", paddingX: isMobile ? "$one" : "none" } }, /* @__PURE__ */ React21.createElement(
    ProgramDetailsSidebarCtaAction,
    {
      isLoading: isActionAwaitingResponse,
      onSelectAction,
      programStatus: status
    }
  )), /* @__PURE__ */ React21.createElement(
    ViewTransitionController,
    {
      views: programDetailsModals,
      handleActiveView: () => activeModal
    }
  )));
};
ProgramDetailsSidebar.propTypes = {
  status: PropTypes9.string,
  progressPercentages: PropTypes9.shape({
    missed: PropTypes9.number,
    completed: PropTypes9.number
  }),
  availablePoints: PropTypes9.number,
  requestLeaveHealthProgram: PropTypes9.func,
  requestStartHealthProgram: PropTypes9.func,
  startProgramMaxEnrolmentModalContent: PropTypes9.shape({
    contentForUsersState: PropTypes9.shape({
      description: PropTypes9.string,
      title: PropTypes9.string
    }),
    imageUrl: PropTypes9.string
  }),
  isUserDeviceConnectableProgram: PropTypes9.bool,
  userHasSufficientWearablePermissions: PropTypes9.bool,
  programDataPoints: PropTypes9.arrayOf(PropTypes9.string),
  programName: PropTypes9.string,
  programId: PropTypes9.string,
  activityStatusCounts: PropTypes9.shape({
    total: PropTypes9.number,
    active: PropTypes9.number,
    upcoming: PropTypes9.number,
    completed: PropTypes9.number,
    expired: PropTypes9.number,
    removed: PropTypes9.number
  }),
  hasError: PropTypes9.bool,
  ready: PropTypes9.bool
};
ProgramDetailsSidebar.defaultProps = {
  status: "",
  progressPercentages: {
    completed: 0,
    missed: 0
  },
  availablePoints: 0,
  requestLeaveHealthProgram: null,
  requestStartHealthProgram: null,
  startProgramMaxEnrolmentModalContent: null,
  isUserDeviceConnectableProgram: false,
  userHasSufficientWearablePermissions: null,
  programDataPoints: null,
  programName: "",
  programId: "",
  activityStatusCounts: {
    total: 0,
    active: 0,
    upcoming: 0,
    completed: 0,
    expired: 0,
    removed: 0
  },
  hasError: false,
  ready: false
};

// src/pages/program-details/parts/program-detail-back-button.component.jsx
import * as React22 from "react";
import { LinkLegacy as Link6 } from "@leagueplatform/routing";
import { BackButtonArrow as BackButtonArrow3 } from "@leagueplatform/web-common-components";
import {
  ENABLE_NEW_JOURNEY_EXPERIENCE as ENABLE_NEW_JOURNEY_EXPERIENCE4,
  JOURNEY_ROUTES as JOURNEY_ROUTES8,
  useBackButtonRouting
} from "@leagueplatform/health-journey-common";
import { useFeatureFlagQuery as useFeatureFlagQuery8 } from "@leagueplatform/user-profile-api";
var ProgramDetailsBackButton = () => {
  const { name, status, programId, goBackPath } = useHealthProgramsProgramDetails();
  const programDetailsAnalytics = useProgramDetailsAnalytics(
    name,
    programId,
    status
  );
  const { data: isNewJourneyExperienceEnabled } = useFeatureFlagQuery8(
    ENABLE_NEW_JOURNEY_EXPERIENCE4
  );
  const backButtonRoute = isNewJourneyExperienceEnabled ? JOURNEY_ROUTES8.programsHome() : goBackPath;
  const { backButtonHref, backButtonOnClick } = useBackButtonRouting({
    backButtonRoute,
    onClickFunc: programDetailsAnalytics.detailsBackButton
  });
  return /* @__PURE__ */ React22.createElement(
    BackButtonArrow3,
    {
      as: Link6,
      color: "onSurface.text.primary",
      "data-testid": "program-details-back-button",
      fontSize: "heading3",
      marginInlineEnd: "one",
      marginY: "half",
      to: backButtonHref,
      onClick: backButtonOnClick
    }
  );
};

// src/pages/program-details/health-program-details.component.jsx
var ActivityContainer2 = genesisStyled5(Box13)(
  ({ theme: { space, breakpoints } }) => `
  display: grid;
  grid-template-columns: auto auto;
  grid-row-gap: ${space.one}px;
  grid-column-gap: ${space.oneAndHalf}px;
  @media screen and (max-width: ${breakpoints.phone}) {
    grid-template-columns: auto;
  }
`
);
var HealthProgramDetails = () => {
  var _a;
  const {
    ready,
    hasError,
    image,
    name,
    description,
    goals,
    status,
    progressPercentages,
    availablePoints,
    programId,
    requestLeaveHealthProgram,
    requestStartHealthProgram,
    startProgramMaxEnrolmentModalContent,
    whatAreConnectedHealthProgramsLink,
    userHasSufficientWearablePermissions,
    programDataPoints,
    isUserDeviceConnectableProgram,
    syncableDevicesString,
    activityStatusCounts,
    achievementImage,
    error
  } = useHealthProgramsProgramDetails();
  const { formatMessage } = useIntl14();
  const { data: isAchievementsFeatureFlagOn } = useFeatureFlagQuery9(ACHIEVEMENTS_ENABLED);
  const { data: isJourneyManagerEnabled } = useFeatureFlagQuery9(
    JOURNEY_MANAGER_ENABLED
  );
  useDocumentTitle2(formatMessage({ id: "PROGRAM_DETAILS" }));
  const [isOpen, setIsOpen] = useState5(false);
  const programDetailsAnalytics = useProgramDetailsAnalytics(
    name,
    programId,
    status
  );
  useEffect5(() => {
    if (ready)
      programDetailsAnalytics.viewProgramDetailsPage();
  }, [ready]);
  const visibleGoals = useMemo4(() => {
    if (isOpen)
      return goals;
    return goals == null ? void 0 : goals.slice(0, 6);
  }, [goals, isOpen]);
  if (!ready) {
    return /* @__PURE__ */ React23.createElement(LoadingIndicator, null);
  }
  if (hasError) {
    return /* @__PURE__ */ React23.createElement(
      Flex10,
      {
        padding: { _: "oneAndHalf", phone: "twoAndHalf" },
        flexDirection: { _: "column", phone: "row" },
        margin: "0 auto",
        justifyContent: "center"
      },
      /* @__PURE__ */ React23.createElement(ProgramDetailsBackButton, null),
      /* @__PURE__ */ React23.createElement(Box13, { marginTop: "three" }, /* @__PURE__ */ React23.createElement(ErrorState2, { error }))
    );
  }
  const isGoalsGreaterThanSix = (goals == null ? void 0 : goals.length) > 6;
  const successStatus2 = handleStaticAsset5(
    "SUCCESS_STATUS" /* SUCCESS_STATUS */
  );
  const enabledBadgePlaceholder2 = handleStaticAsset5(
    "ENABLED_BADGE_PLACEHOLDER" /* ENABLED_BADGE_PLACEHOLDER */
  );
  return /* @__PURE__ */ React23.createElement(
    Flex10,
    {
      flexDirection: { _: "column", laptop: "row" },
      justifyContent: "center",
      paddingTop: { _: "oneAndHalf", phone: "twoAndHalf" },
      gap: { _: "oneAndHalf", phone: "twoAndHalf" }
    },
    /* @__PURE__ */ React23.createElement(
      Flex10,
      {
        flexDirection: { _: "column", tablet: "row" },
        alignItems: "flex-start",
        paddingX: "two"
      },
      /* @__PURE__ */ React23.createElement(ProgramDetailsBackButton, null),
      /* @__PURE__ */ React23.createElement(
        Flex10,
        {
          flexDirection: "column",
          maxWidth: { _: 416, phone: 620, desktop: 778 }
        },
        image && /* @__PURE__ */ React23.createElement(
          CoverImage5,
          {
            src: image,
            alt: formatMessage({ id: "HEALTH_PROGRAMS" }),
            borderRadius: "medium",
            height: { _: 233, phone: 377, desktop: 437 },
            maxWidth: "100%",
            backgroundColor: "highlight.background.subdued",
            marginBottom: "oneAndHalf",
            "data-testid": "program-details-cover-image"
          }
        ),
        /* @__PURE__ */ React23.createElement(
          HeadingTwo3,
          {
            as: "h1",
            fontSize: { _: "initial", phone: "heading1" },
            marginBottom: "three"
          },
          name
        ),
        isUserDeviceConnectableProgram && /* @__PURE__ */ React23.createElement(
          HighlightBanner,
          {
            title: formatMessage({ id: "HEALTH_PROGRAMS_CONNECTED_PROGRAM" }),
            icon: successStatus2,
            marginBottom: "twoAndHalf"
          },
          formatMessage(
            { id: "HEALTH_PROGRAMS_SYNC_DEVICE" },
            { device: syncableDevicesString }
          ),
          " ",
          /* @__PURE__ */ React23.createElement(
            Link7,
            {
              fontSize: "subtitle2",
              href: whatAreConnectedHealthProgramsLink,
              target: "_blank"
            },
            formatMessage({ id: "CONNECT_DEVICES_LEARN_MORE" })
          )
        ),
        /* @__PURE__ */ React23.createElement(HeadingFour, { as: "h2", marginBottom: "oneAndHalf" }, formatMessage({ id: "ABOUT_THIS_PROGRAM" })),
        (_a = splitAtNewlines(description)) == null ? void 0 : _a.map((partDescription) => /* @__PURE__ */ React23.createElement(BodyOne3, { key: partDescription, marginBottom: "oneAndHalf" }, partDescription)),
        isAchievementsFeatureFlagOn && /* @__PURE__ */ React23.createElement(
          AchievementCalloutBanner,
          {
            image: achievementImage || enabledBadgePlaceholder2,
            text: formatMessage({ id: "UNLOCK_ACHIEVEMENTS" })
          }
        ),
        (visibleGoals == null ? void 0 : visibleGoals.length) > 0 && status !== HEALTH_PROGRAM_STATUS.ACTIVE && /* @__PURE__ */ React23.createElement(React23.Fragment, null, /* @__PURE__ */ React23.createElement(HeadingFour, { as: "h2", marginBottom: "oneAndHalf", marginTop: "two" }, formatMessage(
          { id: "ACTIVITIES_PLURALIZATION" },
          { count: goals.length }
        ), isJourneyManagerEnabled && ` (${goals.length})`), /* @__PURE__ */ React23.createElement(ActivityContainer2, null, visibleGoals.map(({ name: goalName, icon_url, goal_id }) => /* @__PURE__ */ React23.createElement(
          Box13,
          {
            key: goal_id,
            width: { phone: "295px", desktop: "377px" }
          },
          /* @__PURE__ */ React23.createElement(HealthProgramCategory, null, /* @__PURE__ */ React23.createElement(
            CoverImage5,
            {
              src: icon_url,
              role: "presentation",
              maxWidth: "37px",
              height: "37px",
              backgroundColor: "highlight.background.subdued",
              marginInlineEnd: "half"
            }
          ), /* @__PURE__ */ React23.createElement(SubtitleTwo3, { as: "h3", fontSize: { phone: "subtitle1" } }, truncateWithEllipses(goalName, 55)))
        ))), isGoalsGreaterThanSix && !isOpen && /* @__PURE__ */ React23.createElement(
          SubtleButton3,
          {
            marginTop: "twoAndHalf",
            width: "166px",
            alignSelf: "center",
            onClick: () => {
              setIsOpen(true);
            }
          },
          formatMessage({ id: "SHOW_MORE" })
        ), isOpen && /* @__PURE__ */ React23.createElement(
          SubtleButton3,
          {
            marginTop: "twoAndHalf",
            width: "166px",
            alignSelf: "center",
            onClick: () => {
              setIsOpen(false);
            }
          },
          formatMessage({ id: "SHOW_LESS" })
        ))
      )
    ),
    /* @__PURE__ */ React23.createElement(
      Box13,
      {
        width: { _: "auto", laptop: "357px" },
        paddingInlineEnd: { _: "inherit", laptop: "twoAndHalf" }
      },
      /* @__PURE__ */ React23.createElement(
        ProgramDetailsSidebar,
        {
          status,
          activityStatusCounts,
          availablePoints,
          progressPercentages,
          programName: name,
          programId,
          requestLeaveHealthProgram,
          requestStartHealthProgram,
          startProgramMaxEnrolmentModalContent,
          isUserDeviceConnectableProgram,
          userHasSufficientWearablePermissions,
          programDataPoints,
          hasError,
          ready
        }
      )
    )
  );
};

// src/pages/category/health-programs-category-page.component.jsx
import React24, { useEffect as useEffect6 } from "react";
import {
  BackButtonArrow as BackButtonArrow4,
  PageHeaderBackground as PageHeaderBackground2,
  SkeletonBox as SkeletonBox4
} from "@leagueplatform/web-common-components";
import {
  BodyOneSecondary as BodyOneSecondary4,
  Box as Box14,
  Flex as Flex11,
  HeadingOne as HeadingOne2
} from "@leagueplatform/genesis-commons";
import { useDocumentTitle as useDocumentTitle3 } from "@leagueplatform/web-common";
import {
  useNavigateLegacy as useNavigate3,
  useParamsLegacy as useParams3
} from "@leagueplatform/routing";
import { useIntl as useIntl15 } from "@leagueplatform/locales";

// src/pages/category/hooks/use-get-health-program-category.hook.js
import { useQuery as useQuery7 } from "@tanstack/react-query";
import {
  GET_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE as GET_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE2,
  getHealthGoalProgramsByCategory
} from "@leagueplatform/health-journey-api";
var useGetHealthProgramsCategory = (categoryId) => useQuery7(
  [GET_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE2, categoryId],
  () => getHealthGoalProgramsByCategory(categoryId)
);

// src/pages/category/hooks/use-health-programs-category-page.hook.js
var useHealthProgramsCategory = ({ categoryId }) => {
  const {
    data: programData,
    isError,
    isLoading
  } = useGetHealthProgramsCategory(categoryId);
  const programs = (programData == null ? void 0 : programData.programs) ? alphaSortObjectsByStringValue(programData.programs, "name") : [];
  const name = (programData == null ? void 0 : programData.name) || "";
  const description = (programData == null ? void 0 : programData.description) || "";
  return {
    name,
    description,
    programs,
    isLoading,
    isError
  };
};

// src/pages/category/health-programs-category-page.component.jsx
var HealthProgramsCategoryPage = () => {
  const { categoryId } = useParams3();
  const { isLoading, name, description, programs } = useHealthProgramsCategory({
    categoryId
  });
  const { formatMessage } = useIntl15();
  const navigate = useNavigate3();
  const programLibraryAnalytics = useProgramLibraryAnalytics();
  const documentTitle = `${formatMessage({
    id: "PAGE_TITLE_HEALTH_PROGRAM_CATEGORY"
  })} - ${name}`;
  useDocumentTitle3(documentTitle);
  useEffect6(() => {
    if (name) {
      programLibraryAnalytics.sendViewProgramCategory(name);
    }
  }, [name]);
  if (isLoading) {
    return /* @__PURE__ */ React24.createElement(SkeletonBox4, { height: "600px", "data-testid": "IS_LOADING" });
  }
  const handleBackClick = () => {
    programLibraryAnalytics.sendLeaveProgramCategory(name);
    navigate(-1);
  };
  return /* @__PURE__ */ React24.createElement(
    Flex11,
    {
      padding: { _: "oneAndHalf", phone: "twoAndHalf" },
      marginX: "auto",
      maxWidth: 1440
    },
    /* @__PURE__ */ React24.createElement(PageHeaderBackground2, null),
    /* @__PURE__ */ React24.createElement(Flex11, { flexDirection: { _: "column", phone: "row" } }, /* @__PURE__ */ React24.createElement(Box14, null, /* @__PURE__ */ React24.createElement(
      BackButtonArrow4,
      {
        fontSize: "heading3",
        color: "onSurface.text.primary",
        marginY: "half",
        marginInlineEnd: "one",
        onClick: handleBackClick
      }
    )), /* @__PURE__ */ React24.createElement(Box14, null, /* @__PURE__ */ React24.createElement(
      HeadingOne2,
      {
        marginBottom: "five",
        fontSize: { _: "heading2", tablet: "heading1" }
      },
      name
    ), description && /* @__PURE__ */ React24.createElement(
      BodyOneSecondary4,
      {
        color: "onSurface.text.subdued",
        marginBottom: "three"
      },
      description
    ), /* @__PURE__ */ React24.createElement(
      HealthProgramsGallery,
      {
        programs,
        analyticsContext: {
          pageContext: "health campaign category",
          programCategory: name
        }
      }
    )))
  );
};

// src/routes.jsx
import { ENABLE_CHALLENGES_WELLNESS_AND_REWARDS as ENABLE_CHALLENGES_WELLNESS_AND_REWARDS4 } from "@leagueplatform/health-journey-common";

// src/pages/all-challenges/all-challenges-by-type.component.tsx
import React28 from "react";
import { useIntl as useIntl18 } from "@leagueplatform/locales";
import { LinkLegacy as Link8 } from "@leagueplatform/routing";
import {
  BackButtonArrow as BackButtonArrow5,
  ErrorState as ErrorState3
} from "@leagueplatform/web-common-components";
import {
  Box as Box16,
  HeadingText as HeadingText4,
  SkeletonRectangle,
  SkeletonText,
  StackItem,
  StackLayout as StackLayout5,
  Tabs as Tabs2
} from "@leagueplatform/genesis-core";
import {
  CHALLENGE_TYPE_GROUP,
  CHALLENGE_TYPE_SOLO,
  CHALLENGE_TYPES as CHALLENGE_TYPES2,
  JOURNEY_ROUTES as JOURNEY_ROUTES9
} from "@leagueplatform/health-journey-common";

// src/hooks/use-get-challenges-by-type.hook.ts
import { useGetAllChallenges as useGetAllChallenges2 } from "@leagueplatform/challenges";
var useGetChallengesByType = (challengeType) => {
  const {
    data: challengeData,
    isLoading,
    isError,
    error
  } = useGetAllChallenges2(challengeType);
  const challenges = (challengeData == null ? void 0 : challengeData.data.length) ? formatChallengesForProgramCards(challengeData) : [];
  return {
    isLoading,
    isError,
    challenges,
    error
  };
};

// src/pages/all-challenges/all-challenges-by-type-tabs.component.tsx
import React25 from "react";
import { useIntl as useIntl16 } from "@leagueplatform/locales";
import { Tabs } from "@leagueplatform/genesis-core";
import { CHALLENGE_TYPES } from "@leagueplatform/health-journey-common";
var AllChallengesByTypeTabs = () => {
  const { $tmap } = useIntl16();
  const getTabMessage = $tmap({
    solo: "CHALLENGE_TYPE_SOLO_TAG",
    group: "CHALLENGE_TYPE_GROUP_TAG"
  });
  return /* @__PURE__ */ React25.createElement(Tabs.TabList, { divider: true, tabDistribution: "hugContents" }, CHALLENGE_TYPES.map((challengeType) => /* @__PURE__ */ React25.createElement(
    Tabs.Tab,
    {
      key: `${challengeType}_tab`,
      value: challengeType,
      css: { padding: "$threeQuarters $oneAndHalf" }
    },
    getTabMessage(challengeType)
  )));
};

// src/pages/all-challenges/challenge-by-type-content.component.tsx
import React27 from "react";
import { useIntl as useIntl17 } from "@leagueplatform/locales";

// src/components/all-challenges-list.component.tsx
import React26 from "react";
import { Box as Box15, StackLayout as StackLayout4 } from "@leagueplatform/genesis-core";
var AllChallengesList = ({ programs }) => /* @__PURE__ */ React26.createElement(
  StackLayout4,
  {
    css: {
      flexWrap: "wrap",
      width: "100%"
    },
    as: "ul",
    orientation: "horizontal",
    horizontalAlignment: "start",
    spacing: "$oneAndHalf"
  },
  programs.map((program) => /* @__PURE__ */ React26.createElement(
    Box15,
    {
      as: "li",
      key: program.program_id,
      css: {
        "@mobile": { width: "100%" },
        "@mobileLandscape": { width: "calc(50% - 13px)" },
        "@tablet": { width: "calc(50% - 13px)" },
        "@laptop": { width: "calc(33% - 13px)" },
        "@desktop": { width: "calc(33% - 13px)" },
        "&>div": { width: "100%" }
      }
    },
    /* @__PURE__ */ React26.createElement(
      HealthProgramsCard,
      {
        tag: program.challenge_info.challenge_type,
        program
      }
    )
  ))
);

// src/pages/all-challenges/challenge-by-type-content.component.tsx
import { HeadingText as HeadingText3, ParagraphText } from "@leagueplatform/genesis-core";
var ChallengeByTypeContent = ({
  challengeType,
  programs
}) => {
  const { $tmap } = useIntl17();
  const title = $tmap({
    group: "VIEW_ALL_GROUP_CHALLENGES_HEADING",
    solo: "VIEW_ALL_SOLO_CHALLENGES_HEADING"
  })(challengeType);
  const description = $tmap({
    group: "VIEW_ALL_CHALLENGES_DESCRIPTION_GROUP",
    solo: "VIEW_ALL_CHALLENGES_DESCRIPTION_SOLO"
  })(challengeType);
  return /* @__PURE__ */ React27.createElement(React27.Fragment, null, /* @__PURE__ */ React27.createElement(
    HeadingText3,
    {
      size: "xxl",
      emphasis: "base",
      level: "2",
      css: { paddingBottom: "$half" }
    },
    title
  ), /* @__PURE__ */ React27.createElement(ParagraphText, { size: "base", emphasis: "base" }, description), /* @__PURE__ */ React27.createElement(AllChallengesList, { programs }));
};

// src/pages/all-challenges/all-challenges-by-type.component.tsx
var noopFunction = () => {
};
var pageContainerStyles = {
  padding: "$one",
  maxWidth: "1205px",
  width: "100%",
  margin: "0 auto"
};
var BasePage = ({ children }) => {
  const { formatMessage } = useIntl18();
  return /* @__PURE__ */ React28.createElement(
    StackLayout5,
    {
      orientation: "horizontal",
      horizontalAlignment: "center",
      css: pageContainerStyles
    },
    /* @__PURE__ */ React28.createElement(StackItem, null, /* @__PURE__ */ React28.createElement(
      BackButtonArrow5,
      {
        as: Link8,
        marginInlineEnd: "one",
        marginTop: "two",
        onClick: noopFunction,
        to: JOURNEY_ROUTES9.programsHome
      }
    )),
    /* @__PURE__ */ React28.createElement(StackItem, { css: { width: "100%" } }, /* @__PURE__ */ React28.createElement(
      StackLayout5,
      {
        css: {
          marginTop: "$two",
          marginBottom: "$oneAndHalf"
        },
        orientation: "horizontal"
      },
      /* @__PURE__ */ React28.createElement(HeadingText4, { size: "xl", level: "1", emphasis: "base" }, formatMessage({
        id: "CHALLENGES"
      }))
    ), children)
  );
};
var AllChallengesByType = () => {
  const {
    challenges: soloChallenges,
    isLoading: soloChallengesLoading,
    isError: soloChallengesError,
    error
  } = useGetChallengesByType(CHALLENGE_TYPE_SOLO);
  const {
    challenges: groupChallenges,
    isLoading: groupChallengesLoading,
    isError: groupChallengesError
  } = useGetChallengesByType(CHALLENGE_TYPE_GROUP);
  const skeletonCardsList = Array.from({ length: 3 }, (_, index) => /* @__PURE__ */ React28.createElement(
    Box16,
    {
      key: index,
      as: "li",
      css: {
        margin: "$one 0",
        flexDirection: "column",
        justifyContent: "center",
        position: "relative",
        padding: "$two 0",
        "@mobile": {
          width: "100%"
        },
        "@mobileLandscape": { width: "calc(50% - 13px)" },
        "@tablet": { width: "calc(50% - 13px)" },
        "@laptop": { width: "calc(33% - 13px)" },
        "@desktop": { width: "calc(33% - 13px)" },
        "&>div": { width: "100%" }
      }
    },
    /* @__PURE__ */ React28.createElement(
      SkeletonRectangle,
      {
        height: "235px",
        css: {
          "@mobile": { height: "111px" },
          "@laptop": {
            width: "384px",
            height: "190px"
          },
          marginBottom: "$half"
        }
      }
    ),
    /* @__PURE__ */ React28.createElement(SkeletonText, { lines: 4 })
  ));
  if (groupChallengesLoading || soloChallengesLoading) {
    return /* @__PURE__ */ React28.createElement("div", { "data-testid": "skeleton-loader" }, /* @__PURE__ */ React28.createElement(BasePage, null, /* @__PURE__ */ React28.createElement(
      StackItem,
      {
        css: {
          width: "100%"
        }
      },
      /* @__PURE__ */ React28.createElement(
        StackLayout5,
        {
          css: {
            marginTop: "$quarter",
            marginBottom: "$oneAndHalf"
          },
          orientation: "vertical",
          spacing: "$one"
        },
        /* @__PURE__ */ React28.createElement(SkeletonText, { header: true, width: "200px" }),
        /* @__PURE__ */ React28.createElement(SkeletonText, { width: "70%" }),
        /* @__PURE__ */ React28.createElement(
          StackLayout5,
          {
            css: {
              flexWrap: "wrap",
              width: "100%"
            },
            as: "ul",
            orientation: "horizontal",
            horizontalAlignment: "start",
            spacing: "$oneAndHalf"
          },
          skeletonCardsList
        )
      )
    )));
  }
  const isErrorState = soloChallengesError || groupChallengesError;
  if (isErrorState)
    return /* @__PURE__ */ React28.createElement(
      StackLayout5,
      {
        horizontalAlignment: "stretch",
        verticalAlignment: "spaceAround",
        css: { width: "100%", marginTop: "$three" },
        "data-testid": "error-state"
      },
      /* @__PURE__ */ React28.createElement(ErrorState3, { error })
    );
  const showTabs = !!(soloChallenges == null ? void 0 : soloChallenges.length) && !!(groupChallenges == null ? void 0 : groupChallenges.length);
  const singleViewPageChallengeType = (soloChallenges == null ? void 0 : soloChallenges.length) ? CHALLENGE_TYPE_SOLO : CHALLENGE_TYPE_GROUP;
  return /* @__PURE__ */ React28.createElement(BasePage, null, showTabs ? /* @__PURE__ */ React28.createElement(Tabs2.Root, { defaultValue: CHALLENGE_TYPES2[0] }, /* @__PURE__ */ React28.createElement(AllChallengesByTypeTabs, null), CHALLENGE_TYPES2.map((challengeType) => /* @__PURE__ */ React28.createElement(
    Tabs2.TabPanel,
    {
      key: `${challengeType}_tab_panel`,
      value: challengeType
    },
    /* @__PURE__ */ React28.createElement(
      ChallengeByTypeContent,
      {
        programs: challengeType === CHALLENGE_TYPE_SOLO ? soloChallenges : groupChallenges,
        challengeType
      }
    )
  ))) : /* @__PURE__ */ React28.createElement(
    ChallengeByTypeContent,
    {
      programs: singleViewPageChallengeType === CHALLENGE_TYPE_SOLO ? soloChallenges : groupChallenges,
      challengeType: singleViewPageChallengeType
    }
  ));
};

// src/routes.jsx
function ProgramOverviewRedirect() {
  const navigate = useNavigate4();
  const { programId } = useParams4();
  useEffect7(() => {
    navigate(`/program?id=${programId}`, { replace: true });
  }, [navigate, programId]);
  return null;
}
function useEnableProgramOverviewMasonry() {
  const [isLocallyEnabled, setIsLocallyEnabled] = useState6(false);
  const defaultServerConfig = {
    enableMasonry2ForCampaignOverview: false
  };
  useEffect7(() => {
    const value = localStorage.getItem("enableProgramOverviewMasonry2");
    setIsLocallyEnabled(value === "true");
  }, []);
  const serverDrivenConfig = useConfigSelection(
    (config) => isConfigSettled(config) ? {
      enableMasonry2ForCampaignOverview: config.config.release_journey_experience_masonry_2_for_program_overview
    } : {},
    defaultServerConfig
  );
  return serverDrivenConfig.enableMasonry2ForCampaignOverview || isLocallyEnabled && !isProduction();
}
var HealthProgramsRoutes = () => {
  const { data: isChallengesWellnessAndRewardsEnabled } = useFeatureFlagQuery10(
    ENABLE_CHALLENGES_WELLNESS_AND_REWARDS4
  );
  const isMasonryCampaignOverviewEnabled = useEnableProgramOverviewMasonry();
  return /* @__PURE__ */ React29.createElement(Routes, null, /* @__PURE__ */ React29.createElement(
    Route,
    {
      path: "category/:categoryId/*",
      element: /* @__PURE__ */ React29.createElement(HealthProgramsCategoryPage, null)
    }
  ), isChallengesWellnessAndRewardsEnabled && /* @__PURE__ */ React29.createElement(Route, { path: "all-challenges", element: /* @__PURE__ */ React29.createElement(AllChallengesByType, null) }), /* @__PURE__ */ React29.createElement(
    Route,
    {
      path: ":programId",
      element: isMasonryCampaignOverviewEnabled ? /* @__PURE__ */ React29.createElement(ProgramOverviewRedirect, null) : /* @__PURE__ */ React29.createElement(HealthProgramDetails, null)
    }
  ), /* @__PURE__ */ React29.createElement(Route, { element: /* @__PURE__ */ React29.createElement(HealthProgramsPage, null), path: "/*" }));
};

// src/pages/program-details/hooks/use-leave-program-modal.hook.ts
import { useState as useState7, useEffect as useEffect8 } from "react";
import {
  useLocationLegacy as useLocation3,
  useNavigateLegacy as useNavigate5
} from "@leagueplatform/routing";
var useLeaveProgramModal = () => {
  var _a;
  const navigate = useNavigate5();
  const location = useLocation3();
  const [showLeaveProgramPulseCheck, setShowLeaveProgramPulseCheck] = useState7(
    ((_a = location == null ? void 0 : location.state) == null ? void 0 : _a.type) === SHOW_PULSE_CHECK_MODAL
  );
  const [leaveProgramPulseCheckState] = useState7(location.state);
  useEffect8(() => {
    if (showLeaveProgramPulseCheck) {
      navigate(location.pathname, { replace: true, state: { type: "" } });
    }
  }, [navigate, location.pathname, showLeaveProgramPulseCheck]);
  return {
    showLeaveProgramPulseCheck,
    setShowLeaveProgramPulseCheck,
    leaveProgramPulseCheckState
  };
};

// src/pages/program-details/parts/health-programs-program-details-leave-program-pulse-check-modal.component.tsx
import React30 from "react";
import {
  Box as Box17,
  BodyOne as BodyOne4,
  Image as Image3,
  HeadingTwo as HeadingTwo4,
  PrimaryButton as PrimaryButton4
} from "@leagueplatform/genesis-commons";
import { LinkLegacy as Link9 } from "@leagueplatform/routing";
import { useIntl as useIntl19 } from "@leagueplatform/locales";
import { handleStaticAsset as handleStaticAsset6 } from "@leagueplatform/asset-config";
var LeaveProgramPulseCheckModal = ({ onClose, programId }) => {
  var _a, _b;
  const { formatMessage } = useIntl19();
  const { data: programData } = useGetHealthProgram(programId);
  const program = (programData == null ? void 0 : programData.program) || {};
  const { campaign_content_config: contentConfig } = program;
  const pulseCheckUrl = (_a = contentConfig == null ? void 0 : contentConfig.pulse_checks[0]) == null ? void 0 : _a.ctaUrl.replace(
    /^\/app\//,
    "/"
  );
  const pulseCheckText = (_b = contentConfig == null ? void 0 : contentConfig.pulse_checks[0]) == null ? void 0 : _b.ctaText;
  const garbageIcon2 = handleStaticAsset6(
    "GARBAGE_ICON" /* GARBAGE_ICON */
  );
  return /* @__PURE__ */ React30.createElement(
    HealthProgramsProgramDetailsModal,
    {
      onClose,
      "aria-labelledby": "program-removed"
    },
    /* @__PURE__ */ React30.createElement(Box17, { textAlign: "center" }, /* @__PURE__ */ React30.createElement(Image3, { width: "120px", src: garbageIcon2, alt: "" }), /* @__PURE__ */ React30.createElement(HeadingTwo4, { id: "program-removed", marginTop: "half", marginBottom: "half" }, formatMessage({ id: "PROGRAM_REMOVED" })), /* @__PURE__ */ React30.createElement(BodyOne4, { color: "onSurface.text.subdued", marginBottom: "two" }, formatMessage({ id: "YOU_WILL_NO_LONGER_SEE_IN_JOURNEY" })), /* @__PURE__ */ React30.createElement(
      PrimaryButton4,
      {
        "data-testid": "remove-program-pulse-check",
        as: Link9,
        to: pulseCheckUrl,
        textDecoration: "none"
      },
      pulseCheckText
    ))
  );
};

// src/components/curated-health-program-carousel.component.jsx
import React31 from "react";
import PropTypes10 from "prop-types";
var CuratedHealthProgramCarousel = ({
  carouselType,
  carouselsCategory
}) => {
  const type = !Object.values(CURATED_CAROUSEL_TYPES).includes(carouselType) ? CURATED_CAROUSEL_TYPES.HOMEFEED : carouselType;
  const {
    data: healthProgramSuggestedCarouselsData,
    isLoading: isHealthProgramCuratedCarouselsLoading
  } = useHealthProgramCuratedCarousels(type);
  return /* @__PURE__ */ React31.createElement(
    HealthProgramCarousels,
    {
      isLoading: isHealthProgramCuratedCarouselsLoading,
      carousels: healthProgramSuggestedCarouselsData == null ? void 0 : healthProgramSuggestedCarouselsData.carousels,
      carouselsCategory
    }
  );
};
CuratedHealthProgramCarousel.propTypes = {
  carouselType: PropTypes10.string,
  carouselsCategory: PropTypes10.string
};
CuratedHealthProgramCarousel.defaultProps = {
  carouselType: "",
  carouselsCategory: ""
};

// src/index.tsx
initModule();
export {
  CuratedHealthProgramCarousel,
  DeviceTrackingModal,
  HEALTH_PROGRAM_STATUS,
  HealthProgramCarousels,
  HealthProgramCategory,
  HealthProgramDetails,
  HealthProgramsCard,
  HealthProgramsCategoryPage,
  HealthProgramsGallery,
  HealthProgramsList,
  HealthProgramsPage,
  HealthProgramsRoutes,
  LeaveProgramPulseCheckModal,
  SHOW_PULSE_CHECK_MODAL,
  UnavailableDeviceConnectModal,
  programProgressBarSegmentFactory,
  programsBasePropTypes,
  programsListItemPropType,
  programsListPropType,
  programsPropTypes,
  useActiveCampaignInfo,
  useHealthProgramCategories,
  useHealthProgramCuratedCarousels,
  useHealthProgramSuggestedCarousels,
  useHealthProgramsCategory,
  useLeaveProgramModal,
  useProgramLibraryAnalytics
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/health-programs'] = window.leagueSDKsPresent['@leagueplatform/health-programs'] || [];
    window.leagueSDKsPresent['@leagueplatform/health-programs'].push('2.27.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/health-programs'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/health-programs module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map